<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="300"
    height="505"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 263.4 419.7"
    id="milestone-analyticsuk"
    role="presentation"
    aria-labelledby="analyticsuklaunch"
  >
    <title id="analyticsuklaunch">Launch of analytics</title>
    <path
      id="Shadow_4"
      data-name="Shadow 4"
      d="M136.7,315l30.1,17.5-1,.7-30.3-17.5Zm38.6,11.7c-.2.3-.3.7-.7.9l-30.1-17.3,1.2-.5Zm-2.4,2.1-1.2.7-30.1-17.3,1-.7Zm-3.1,1.9-1,.5-30.1-17.3,1-.7Zm-22,12.7c-.2,0-.2.2-.3.2l-29.4-17a7.3,7.3,0,0,1,.5-.9l20.6,11.9.3-.2,59.7,34.4-.2.2-.9.5Zm-12.3-3.7,1-.7,59.9,34.6-1,.7Zm-3.1,1.8,1-.5,59.7,34.4-.2.2-.7.5Zm-3,1.7,1-.5,59.9,34.4-1,.7Zm-3.1,1.7,1-.5L187.2,379l-1,.5Zm-2.9,1.9,1-.7,59.9,34.6-1,.5Zm-3.1,1.7,1-.7,59.9,34.6-.2.2-.9.5Zm-3,1.8,1-.7,59.9,34.6-1,.7Zm-3.1,1.7,1-.5,59.7,34.4-.2.2-.7.5Zm-3.1,1.7,1.2-.5L172,387.6v.2l-1,.5Zm-2.1,2.5a7.3,7.3,0,0,1,.5-.9l59.4,34.3-.2.2a1.9,1.9,0,0,1-1,.3Zm-.5,1.9,56.2,32.5h-2.2l-53.8-31A3.4,3.4,0,0,0,108.5,358.1Zm54.7-23.6-.3.2-30.1-17.5,1-.7,22,12.8h.7l55.2,31.8c0,.3.2.9,0,1.2Zm-3.1,1.9-.3.2-30.1-17.5,1-.7,20.8,11.9a.4.4,0,0,0,.3-.2L211,364.5a4.4,4.4,0,0,1-.7.9Zm47.4,30.8-50.4-29.1-.3.2-30.3-17.5,1.2-.5,20.6,11.9.3-.2,59.9,34.4ZM154,339.9l-.3.2-30.1-17.3,1-.7L145.2,334l.3-.2,59.9,34.6-1,.5Zm-2.9,1.7-.3.3-30.1-17.5,1-.7,20.6,11.9.3-.2L202.5,370l-1,.5Zm37.7,3.3,30.1,17.5-1,.7-30.3-17.5Zm38.6,11.8c-.2.3-.3.7-.7.9l-30.1-17.3,1.2-.5Zm-2.4,2-1.2.7-30.1-17.3,1-.7Zm-3.1,1.9-1,.5-30.1-17.3,1-.7Zm-22,12.7c-.2,0-.2.2-.3.2l-29.4-17a7.3,7.3,0,0,1,.5-.9l20.6,11.9.3-.2,59.7,34.4-.2.2-.9.5Zm-12.3-3.7,1-.7,59.9,34.6-1,.7Zm-3.1,1.8,1-.5,59.7,34.4-.2.2-.7.5Zm-3,1.7,1-.5L242.4,407l-1,.7Zm-3.1,1.7,1-.5,59.9,34.6-1,.5Zm-2.9,1.9,1-.7,59.9,34.6-1,.5Zm-3.1,1.8,1-.7,59.9,34.6-.2.2-.9.5Zm-3,1.7,1-.7,59.9,34.6-1,.7Zm-3.1,1.7,1-.5L227,415.8l-.2.2-.7.5Zm-3.1,1.7,1.2-.5,59.7,34.4v.2l-1,.5Zm-2.1,2.5a7.3,7.3,0,0,1,.5-.9L221,419.5l-.2.2a1.9,1.9,0,0,1-1,.3Zm-.5,1.9,56.2,32.5h-2.2l-53.8-31A3.4,3.4,0,0,0,160.6,388Zm54.7-23.6-.3.2-30.1-17.5,1-.7,22,12.8h.7L263.8,391c0,.3.2.9,0,1.2Zm-3.1,1.9-.3.2L181.7,349l1-.7,20.8,11.9a.4.4,0,0,0,.3-.2L263,394.4a4.4,4.4,0,0,1-.7.9Zm47.4,30.8L209.2,368l-.3.2-30.3-17.5,1.2-.5,20.6,11.9.3-.2,59.9,34.4Zm-53.5-27.3-.3.2-30.1-17.3,1-.7,20.6,11.9.3-.2,59.9,34.6-1,.5Zm-2.9,1.7-.3.3-30.1-17.5,1-.7,20.6,11.9.3-.2,59.9,34.6-1,.5Z"
      transform="translate(-0.5 -0.8)"
    />
    <path
      id="Shadow3"
      d="M74.6,358.7l.7-.3L56.6,347.6l.9-.3,23.6,13.6-.7.4L99.1,372l-.9.4Zm21.4,15L72.2,360.1l.9-.3L54.4,349l.9-.5,23.6,13.8-.7.4,18.7,10.8ZM69.9,361.5l.7-.4L52.4,350.6c0-.4.2-.5.5-.7l23.6,13.6c-.2.2-.5.2-.9.3l18.9,10.8-.9.5Zm-2.5,1.4.9-.5,23.6,13.8-.7.4Zm-2.2,1.4.9-.5,23.6,13.6-.9.5Zm-2.3,1.4.7-.5,23.8,13.6-.9.5Zm-2.4,1.4.9-.5L85,380.2l-.9.5Zm-2,1.6c0-.3.2-.5.5-.7l23.6,13.6a1.9,1.9,0,0,1-1,.3Zm20.8-12.8.7-.4L61.3,344.7l.9-.5,23.6,13.6-.7.4,18.2,10.5c-.2.4-.2.5-.5.7Zm21.4,15.2L77.1,357.3l.7-.4L59.1,346.1l.9-.3,23.6,13.6-.7.4,18.7,10.8ZM75.3,346.4a2.2,2.2,0,0,1-.2-1.1L102.6,361a2.7,2.7,0,0,1-1.2.2l-10.7-6.1-.9.5L66.2,342l.9-.5Zm-10.7-3.5,23.6,13.6-.9.5L63.7,343.4ZM76,344l.9-.3L105.1,360l-.9.5L93,353.8l-.9.5L68.5,340.7l.9-.5Zm21.7-12.3a3,3,0,0,1,1.9.2l9.3,5.4,7.2,4.4h.2l23.6,13.6-.9.5Zm39.9,24.9-.9.5L94.9,333l.9-.5Zm-45-22.2.7-.5L135.1,358l-.7.5Zm-2.4,1.4.9-.5,41.8,24.1-.9.5ZM87.9,337l.9-.4,41.8,24.1-.9.4Zm-2.4,1.4.9-.4,41.8,24.1-.9.4Zm-2.3,1.4.9-.4,41.8,24.1-.9.3Zm14,11c-.2.2-.2.5-.5.7L73,337.9a2.1,2.1,0,0,1,1-.4l6.6,3.9.9-.5L123.3,365a1.5,1.5,0,0,1-.9.4Zm-7.5-1.6,5.6,3.2-.9.5L70.8,339.3l.9-.5,6.8,3.9.9-.5L108.6,359a2.2,2.2,0,0,0-1.6,0Zm30.6-9.9a2.1,2.1,0,0,1,1.1-.4l22.9,13.3c0,.4-.2.5-.4.7Zm-2.5,1.4.9-.5,23.6,13.6-.9.5Z"
      transform="translate(-0.5 -0.8)"
    />
    <path
      id="Shadow2"
      d="M184.6,316.7l.7-.3-18.7-10.8.9-.3,23.6,13.6-.7.4,18.7,10.8-.9.4Zm21.4,15-23.8-13.6.9-.3L164.4,307l.9-.5,23.6,13.8-.7.4,18.7,10.8Zm-26.1-12.2.7-.4-18.2-10.5c0-.4.2-.5.5-.7l23.6,13.6c-.2.2-.5.2-.9.3l18.9,10.8-.9.5Zm-2.5,1.4.9-.5,23.6,13.8-.7.4Zm-2.2,1.4.9-.5,23.6,13.6-.9.5Zm-2.3,1.4.7-.5,23.8,13.6-.9.5Zm-2.5,1.4.9-.5,23.6,13.6-.9.5Zm-1.9,1.6c0-.3.2-.5.5-.7l23.6,13.6a1.9,1.9,0,0,1-1,.3Zm20.8-12.8.7-.4-18.7-10.8.9-.5,23.6,13.6-.7.4,18.2,10.5c-.2.4-.2.5-.5.7Zm21.4,15.2-23.6-13.8.7-.4-18.7-10.8.9-.3,23.6,13.6-.7.4,18.7,10.8Zm-25.4-24.7a2.2,2.2,0,0,1-.2-1.1L212.6,319a2.5,2.5,0,0,1-1.2.2l-10.7-6.1-.9.5L176.2,300l.9-.5Zm-10.7-3.5,23.6,13.6-.9.5-23.6-13.6ZM186,302l.9-.3L215.1,318l-.9.5L203,311.9l-.9.5-23.6-13.6.9-.5Zm21.7-12.3a3,3,0,0,1,1.9.2l9.3,5.4,7.2,4.4h.2l23.6,13.6-.9.5Zm39.9,24.9-.9.5L204.9,291l.9-.5Zm-45-22.2.7-.5L245.1,316l-.7.5Zm-2.4,1.4.9-.5,41.8,24.1-.9.5Zm-2.3,1.2.9-.4,41.8,24.1-.9.4Zm-2.4,1.4.9-.4,41.8,24.1-.9.4Zm-2.3,1.4.9-.4,41.8,24.1-.9.3Zm14,11c-.2.2-.2.5-.5.7L183,295.9a2.5,2.5,0,0,1,1.1-.4l6.6,3.9.9-.5L233.4,323c-.4.2-.5.4-.9.4Zm-7.5-1.6,5.6,3.2-.9.5-23.6-13.6.9-.5,6.8,3.9.9-.5L218.6,317a2.2,2.2,0,0,0-1.6,0Zm30.6-9.9a2.1,2.1,0,0,1,1-.4l22.9,13.3c0,.4-.2.5-.4.7Zm-2.5,1.4.9-.5,23.6,13.6-.9.5Z"
      transform="translate(-0.5 -0.8)"
    />
    <path
      id="Shadow1"
      d="M34.2,255.9l30.1,17.5-1,.7L33,256.6Zm38.5,11.8c-.2.3-.3.7-.7.9L41.9,251.3l1.2-.5Zm-2.4,2-1.2.7L39,253.1l1-.7Zm-3.1,1.9-1,.5L36.1,254.8l1-.7Zm-22,12.7c-.2,0-.2.2-.3.2l-29.4-17a7.3,7.3,0,0,1,.5-.9l20.6,11.9.3-.2,59.7,34.4-.2.2-.9.5Zm-12.3-3.7,1-.7,59.9,34.6-1,.7Zm-3.1,1.8,1-.5,59.7,34.4-.2.2-.7.5Zm-2.9,1.7,1-.5L87.8,318l-1,.7Zm-3.1,1.7,1-.5,59.9,34.6-1,.5Zm-3,1.9,1-.7,59.9,34.6-1,.5Zm-3.1,1.8,1-.7,59.9,34.6-.2.2-.9.5Zm-2.9,1.7,1-.7,59.9,34.6-1,.7Zm-3.1,1.7,1-.5,59.7,34.4-.2.2-.7.5Zm-3.2,1.8,1.2-.5,59.7,34.4v.2l-1,.5Zm-2,2.4a7.3,7.3,0,0,1,.5-.9l59.4,34.3-.2.2a1.9,1.9,0,0,1-1,.3ZM5.9,299l56.2,32.5H59.9l-53.8-31A3.4,3.4,0,0,0,5.9,299Zm54.7-23.6-.3.2L30.2,258.1l1-.7,22,12.8h.7L109.1,302c0,.3.2.9,0,1.2Zm-3.1,1.9-.3.2L27.1,260l1-.7,20.8,11.9a.4.4,0,0,0,.3-.2l59.2,34.4a4.4,4.4,0,0,1-.7.9Zm47.4,30.9L54.5,279.1l-.3.2L23.9,261.8l1.2-.5,20.6,11.9.3-.2,59.9,34.4ZM51.5,280.8l-.3.2L21,263.7l1-.7,20.6,11.9.3-.2,59.9,34.6-1,.5Zm-3,1.7-.3.3L18.1,265.3l1-.7,20.6,11.9.3-.2,59.9,34.6-1,.5Zm37.8,3.3,30.1,17.5-1,.7L85,286.5Zm38.5,11.8c-.2.3-.3.7-.7.9L94,281.1l1.2-.5Zm-2.4,2-1.2.7L91.1,283l1-.7Zm-3.1,1.9-1,.5L88.2,284.7l1-.7Zm-22,12.7c-.2,0-.2.2-.3.2l-29.4-17a7.3,7.3,0,0,1,.5-.9l20.6,11.9.3-.2,59.7,34.4-.2.2-.9.5ZM85,310.5l1-.7,59.9,34.6-1,.7Zm-3.1,1.8,1-.5,59.7,34.4-.2.2-.7.5ZM79,314l1-.5,59.9,34.4-1,.7Zm-3.1,1.7,1-.5,59.9,34.6-1,.5Zm-3,1.9,1-.7,59.9,34.6-1,.5Zm-3.1,1.8,1-.7,59.9,34.6-.2.2-.9.5Zm-2.9,1.7,1-.7L127.8,355l-1,.7Zm-3.1,1.7,1-.5,59.7,34.4-.2.2-.7.5Zm-3.2,1.8,1.2-.5,59.7,34.4v.2l-1,.5Zm-2,2.4a7.3,7.3,0,0,1,.5-.9l59.4,34.3-.2.2a1.9,1.9,0,0,1-1,.3Zm-.6,1.9,56.2,32.5H112l-53.8-31A3.6,3.6,0,0,0,58,328.9Zm54.7-23.5-.3.2L82.3,288.1l1-.7,22,12.8h.7L161.2,332c0,.3.2.9,0,1.2Zm-3.1,1.9-.3.2L79.2,290l1-.7L101,301.2a.4.4,0,0,0,.3-.2l59.2,34.4a4.4,4.4,0,0,1-.7.9ZM157,338.1,106.7,309l-.3.2L76,291.7l1.2-.5,20.6,11.9.3-.2L158,337.3Zm-53.4-27.4-.3.2L73.2,293.6l1-.7,20.6,11.9.3-.2L155,339.2l-1,.5Zm-3,1.8-.3.3L70.2,295.3l1-.7,20.6,11.9.3-.2L152,341l-1,.5Z"
      transform="translate(-0.5 -0.8)"
    />
    <g id="Booth">
      <path
        class="cls-1"
        d="M48.9,215.7h-.5l-1.5-.9v7.8l1.9,1.1v-7.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="51.3 213.3 49.4 214.4 49.4 223 51.3 221.9 51.3 213.3" />
      <path
        class="cls-1"
        d="M91.6,199.7l2-1.2v-8.3L52.8,213.5V222l3.3-1.9h0a.4.4,0,0,1-.2-.4v-7.1a.5.5,0,0,1,.2-.4l34.8-20.1h.5a.4.4,0,0,1,.2.4v7.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M50.1,224.8l-.2.2v83l4.4-2.5V229.8a.5.5,0,0,1,.2-.4l37.8-21.8h.5a.4.4,0,0,1,.2.4v75.1l3.5-2V198Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-2" d="M70.9,208.5h0l-1.6,1h0l1.3-.7h.3Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-2" d="M64.8,212.1l-1.5.9h0l1.2-.7h.4v-.3Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-2" d="M70.8,207.2h0v-.3l-.4.2Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-2" d="M64.8,210.6v-.2l-.3.2Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-2"
        d="M79.7,203.7a1.8,1.8,0,0,0,.8-1.7,1.5,1.5,0,0,0-.1-.6h-.2a1.9,1.9,0,0,0-.8,1.7,1.5,1.5,0,0,0,.1.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-2" d="M72.5,206v.2h.1c.1-.1.3-.2.4-.4Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-2"
        d="M56.8,213v5.9l33.8-19.5v-5.9Zm32.1-16.8c0,.2-.1.3-.3.4l-.5.3h.4a.4.4,0,0,1,.2.4v.5c0,.2-.1.3-.3.4l-1.6.9h0l1.3-.7h.5a.4.4,0,0,1,.2.4v.6a.5.5,0,0,1-.2.4L86,201.5h-.5a.5.5,0,0,1-.2.4l-.6.4a.6.6,0,0,1-.7-.1l-.8-1v1.6c0,.2-.1.3-.3.4l-.6.3h-.5c-.1-.1-.2-.2-.2-.3A4,4,0,0,1,80,205l-1.1.3-.7-.2-.3-.2v.9c0,.2-.1.4-.3.4l-.7.3h-.5a.8.8,0,0,1-.2-.4v-1l-.6.4V207a.5.5,0,0,1-.2.4l-.7.4h-.5a.5.5,0,0,1-.3-.4v-1.1a2,2,0,0,1-.9.9l-.7.4v1.3c0,.2-.1.3-.3.4l-.6.3h-.3c0,.1-.1.2-.2.3l-2.6,1.5H68a.2.2,0,0,1-.2.2l-2.4,1.4H65l-.2.3-2.6,1.5h-.5a.4.4,0,0,1-.2-.4v-2.6l-.5.3v3.3c0,.2-.1.3-.3.4l-.6.3h-.5a.4.4,0,0,1-.2-.4v-2.7l-.4.2h-.5a.4.4,0,0,1-.2-.4v-.6a.5.5,0,0,1,.2-.4l2.9-1.7h.2a.2.2,0,0,1,.2-.2l2.6-1.5h.4l.2-.3.6-.3h.5a.4.4,0,0,1,.2.4V211l1.1-.6h.2V207a.5.5,0,0,1,.2-.4l2.5-1.5h.4a.5.5,0,0,1,.2-.4l1.5-.9h0c.2-.1.9-.5,1.4-.2h0v-.4a.5.5,0,0,1,.2-.4l.7-.4h.5a.5.5,0,0,1,.3.4v.8l.6-.4v-1.4c0-.2.1-.4.3-.4l.7-.3h.5l.2.3a3.8,3.8,0,0,1,1.6-1.7c.8-.5,1.3-.4,1.6-.2l.4.3v-.9a.5.5,0,0,1,.2-.4l.7-.4a.6.6,0,0,1,.7.1l.7.9v-1.6a.5.5,0,0,1,.2-.4l.6-.4H85a.5.5,0,0,1,.2-.4l2.6-1.5a.5.5,0,0,1,.5,0,.4.4,0,0,1,.2.4v1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M88.2,195.2l-2.6,1.5a.5.5,0,0,0-.2.4h-.5l-.6.4a.5.5,0,0,0-.2.4v1.6l-.7-.9a.5.5,0,0,0-.7-.1l-.7.4a.4.4,0,0,0-.2.4v.9a.5.5,0,0,0-.4-.3,1.4,1.4,0,0,0-1.6.2,4.4,4.4,0,0,0-1.6,1.7c0-.1-.1-.3-.2-.3h-.5l-.7.3a.5.5,0,0,0-.3.4v1.4l-.6.4v-.8c0-.2-.1-.3-.3-.4a.5.5,0,0,0-.5,0l-.7.4a.4.4,0,0,0-.2.4v.4h0a1.3,1.3,0,0,0-1.4.2h0l-1.5.9a.5.5,0,0,0-.2.4h-.4L68.2,207a.4.4,0,0,0-.2.4v3.3c-.1,0-.2,0-.2.1l-1.1.6v-2.6a.5.5,0,0,0-.2-.4H66l-.6.3-.2.3h-.4l-2.6,1.5-.2.2h-.2l-2.9,1.7a.4.4,0,0,0-.2.4v.6a.5.5,0,0,0,.2.4h.5l.4-.2v2.7a.5.5,0,0,0,.2.4h.5l.6-.3a.5.5,0,0,0,.3-.4v-3.3l.5-.3v2.6a.5.5,0,0,0,.2.4h.5l2.6-1.5c.1-.1.2-.2.2-.3h.4l2.4-1.4.2-.2h.3l2.6-1.5.2-.3h.3l.6-.3a.5.5,0,0,0,.3-.4V208l.7-.4a2,2,0,0,0,.9-.9v1.1c0,.2.1.3.3.4h.5l.7-.4a.4.4,0,0,0,.2-.4v-1.5l.6-.4v1a.5.5,0,0,0,.2.4h.5l.7-.3a.5.5,0,0,0,.3-.4v-.9l.3.2.7.2,1.1-.3a4,4,0,0,0,1.6-1.8l.2.3h.5l.6-.3a.5.5,0,0,0,.3-.4v-1.6l.8,1a.6.6,0,0,0,.7.1l.6-.4a.5.5,0,0,0,.2-.4h.5l2.6-1.5a.4.4,0,0,0,.2-.4v-.6a.5.5,0,0,0-.2-.4h-.5l-1.3.7h0l1.6-.9a.5.5,0,0,0,.3-.4v-.5a.5.5,0,0,0-.2-.4h-.4l.5-.3a.5.5,0,0,0,.3-.4V196a.5.5,0,0,0-.2-.4C88.5,195.1,88.3,195.1,88.2,195.2ZM64.4,212.3l-1.2.7h0l1.5-.9v.2Zm.4-1.9v.2h0Zm5.7-3.3.4-.2v.3h-.4Zm0,1.7-1.3.7h0l1.6-.9h0v.3Zm2.1-2.7h-.1V206l.5-.3C72.9,205.9,72.7,206,72.6,206.1Zm6.8-2.3a1.5,1.5,0,0,1-.1-.6,1.8,1.8,0,0,1,.8-1.7h.2a1.5,1.5,0,0,1,.1.6,1.8,1.8,0,0,1-.8,1.7h-.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M90.9,251.2a2.2,2.2,0,0,1-.9,1l-.6.2h-.5a2,2,0,0,1-.7-1v15c0,.1,0,.2-.1.2V280c0,.2-.1.3-.3.4l-6.9,4a.2.2,0,0,1-.2.2L78.4,286H78l-8.7,5-.2.3-2.5,1.4h-.3l-6.7,3.8h-.2c-.1,0-.2,0-.2-.1a.4.4,0,0,1-.2-.4V283a.3.3,0,0,0-.1-.2V280c0-.1,0-.2.1-.2V264c0-.1,0-.2.1-.2V251.3a.3.3,0,0,0-.1-.2v-2.8c0-.1,0-.2.1-.2V234.6c0-.2.1-.3.3-.4l6.8-3.9c0-.1.1-.2.2-.3l2.5-1.4h.3l8.7-5,.2-.3,2.4-1.3h.3l6.8-3.9H88a.4.4,0,0,1,.2.4v16.3c0,.1,0,.2-.1.2v13.2a2.9,2.9,0,0,1,1.2-1.9,1.1,1.1,0,0,1,1.1,0l.3.3V211.2L56.4,231.1v73.4l34.5-19.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M55.3,230.1v74.8h.1V230.5c0-.2.1-.3.3-.4l35.5-20.4h.5a.4.4,0,0,1,.2.4v73.7H92V208.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-2" points="65.6 247 59.5 250.4 59.5 262.3 65.6 258.8 65.6 247" />
      <polygon class="cls-2" points="65.6 262.8 59.5 266.3 59.5 278.2 65.6 274.7 65.6 262.8" />
      <polygon class="cls-2" points="69 256.8 77.3 252.1 77.3 240.2 69 244.9 69 256.8" />
      <polygon class="cls-2" points="86.8 266.4 80.7 269.9 80.7 282.4 86.8 278.9 86.8 266.4" />
      <polygon class="cls-2" points="80.7 266 86.8 262.5 86.8 250.6 80.7 254.1 80.7 266" />
      <polygon class="cls-2" points="59.5 246.5 65.6 243 65.6 230.5 59.5 233.9 59.5 246.5" />
      <polygon class="cls-2" points="80.7 250.1 86.8 246.6 86.8 234.7 80.7 238.2 80.7 250.1" />
      <polygon class="cls-2" points="77.3 236.3 77.3 223.7 69 228.5 69 241 77.3 236.3" />
      <polygon class="cls-2" points="77.3 256 69 260.8 69 272.7 77.3 267.9 77.3 256" />
      <polygon class="cls-2" points="69 276.7 69 289.1 77.3 284.4 77.3 271.9 69 276.7" />
      <polygon class="cls-2" points="59.5 282.1 59.5 294.6 65.6 291.1 65.6 278.7 59.5 282.1" />
      <polygon class="cls-2" points="80.7 234.3 86.8 230.8 86.8 218.2 80.7 221.8 80.7 234.3" />
      <polygon class="cls-1" points="79.7 270.5 78.3 271.3 78.3 284 79.7 283.1 79.7 270.5" />
      <polygon class="cls-1" points="79.7 238.8 78.3 239.6 78.3 251.5 79.7 250.7 79.7 238.8" />
      <polygon class="cls-1" points="79.7 254.6 78.3 255.5 78.3 267.4 79.7 266.6 79.7 254.6" />
      <polygon class="cls-1" points="78.3 235.7 79.7 234.9 79.7 222.2 78.3 223 78.3 235.7" />
      <polygon class="cls-1" points="66.6 258.2 68 257.4 68 245.5 66.6 246.4 66.6 258.2" />
      <polygon class="cls-1" points="66.6 242.4 68 241.6 68 228.9 66.6 229.7 66.6 242.4" />
      <polygon class="cls-1" points="66.6 274.1 68 273.3 68 261.4 66.6 262.2 66.6 274.1" />
      <polygon class="cls-1" points="68 277.2 66.6 278.1 66.6 290.7 68 289.9 68 277.2" />
      <polygon class="cls-1" points="59.5 247.7 59.5 249.3 86.9 233.5 86.9 231.9 59.5 247.7" />
      <polygon class="cls-1" points="86.9 249.4 86.9 247.7 59.5 263.5 59.5 265.1 86.9 249.4" />
      <polygon class="cls-1" points="86.9 265.2 86.9 263.6 59.5 279.4 59.5 281 86.9 265.2" />
      <path
        class="cls-1"
        d="M89.5,251.4a4,4,0,0,0,1-3,2.1,2.1,0,0,0-.4-1.5H90a3.8,3.8,0,0,0-1,2.9C89.1,250.9,89.4,251.4,89.5,251.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M7.3,199.7h0v-7.1a.5.5,0,0,1,.2-.4h.1l-2.4-1.4v7.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M46,214.3l-2.9-1.7h0v7.1a.5.5,0,0,1-.2.4h0l3.2,1.8v-7.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M5.7,208a.5.5,0,0,1,.2-.4h.5l37.8,21.8a.4.4,0,0,1,.2.4v75.7l4.4,2.5V225.1l-.2-.3L2.3,198v83.1l3.4,2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-2" d="M22.1,203.5Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-2" d="M24.2,204.9l-.4-.4h-.1v.2Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-2"
        d="M31.4,210.1a1.9,1.9,0,0,0-.8-1.7h-.2s-.1.1-.1.5a1.9,1.9,0,0,0,.8,1.7h.2S31.4,210.5,31.4,210.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-2" d="M16.2,201.6h-.4l-1.1-.6h0l1.5.9Z" transform="translate(-0.5 -0.8)" />
      <polygon class="cls-2" points="37.2 213.5 38 214 37.2 213.4 37.2 213.5" />
      <path class="cls-2" d="M22.1,204.9h-.5l-1-.6h0l1.5.9Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-2"
        d="M8.3,193.5v5.9l33.8,19.5V213Zm1.6,2.2c0-.2.1-.3.3-.4a.5.5,0,0,1,.5,0l2.8,1.7h.4l2.5,1.5.2.3h.3l.6.3a.5.5,0,0,1,.3.4v3.1l1.2.7V201a.5.5,0,0,1,.2-.4h.5l2.5,1.4c.1.1.2.2.2.3h.4l1.5.9h0a2.6,2.6,0,0,1,1,1.1h.6l.6.4a.5.5,0,0,1,.2.4v1.3l.6.4V206c0-.2.1-.4.3-.4h.5l.6.4a.5.5,0,0,1,.2.4v.8l.3-.2a1.7,1.7,0,0,1,1.7.1h0a4.1,4.1,0,0,1,1.5,1.7c0-.1.1-.2.2-.3h.5l.7.3c.1.1.2.1.2.3l.6,1.6v-.4c0-.2.1-.3.3-.4h.5l.5.3a.5.5,0,0,1,.2.4h.5l2.5,1.5a.4.4,0,0,1,.2.4v.5a.5.5,0,0,1-.2.4h-.2a.4.4,0,0,1,.2.4v.6c0,.2-.1.3-.3.4h-.4l.7.4a.4.4,0,0,1,.2.4v.6a.5.5,0,0,1-.2.4h-.5l-2.5-1.5a.5.5,0,0,1-.2-.4h-.5l-.6-.4-.2-.2-.6-1.6v.4a.5.5,0,0,1-.2.4h-.5l-.6-.3a.5.5,0,0,1-.3-.5V212l-.3.2-.6.2-1-.3a4.1,4.1,0,0,1-1.5-1.7l-.2.3h-.3c-.1,0-.2,0-.2-.1l-.6-.3a.5.5,0,0,1-.3-.4v-1.5l-.6-.3v.9a.5.5,0,0,1-.2.4h-.5l-.6-.3a.5.5,0,0,1-.3-.4v-2h0a1.2,1.2,0,0,1-1.3-.1h-.2v.7a.5.5,0,0,1-.2.4h-.3c-.1,0-.2,0-.2-.1l-.6-.3c-.1-.1-.2-.1-.2-.2h-.4l-2.5-1.5-.2-.2h-.2L16.5,204c-.1-.1-.2-.2-.2-.3h-.4l-2.5-1.5a.4.4,0,0,1-.2-.4v-3.1H13l-.3-.2v2.5a.5.5,0,0,1-.2.4H12l-.6-.3a.5.5,0,0,1-.3-.4v-3.1l-.9-.5a.5.5,0,0,1-.3-.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M48.2,214.4v-3.7L1.6,183.6v3.8l.2.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M42.4,230.8,7.9,210.9v73.4l34.4,19.9V230.8ZM20.2,286.1l-2.4-1.4c-.1-.1-.2-.2-.2-.3l-6.8-3.9a.4.4,0,0,1-.2-.4V263.7c0-.1,0-.2.1-.2V247.9c0-.1,0-.2.1-.2V232.2c0-.1,0-.2.1-.2V218.6a.5.5,0,0,1,.2-.4h.5l6.7,3.9h.3l2.4,1.3c.1.1.2.2.2.3l8.7,5H30l2.4,1.4.2.3,6.8,3.9a.4.4,0,0,1,.2.4v16.5c0,.1,0,.2-.1.2V264a.3.3,0,0,0,.1.2V267c0,.1,0,.2-.1.2v15.6c0,.1,0,.2-.1.2v13.3a.5.5,0,0,1-.2.4h-.2s-.2,0-.2-.1l-6.7-3.8h-.4l-2.4-1.4-.2-.3-8.7-5h-.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M43.6,304.9V230.1L6.7,208.9v74.8h.2V210.1a.5.5,0,0,1,.2-.4h.5L43,230.1a.5.5,0,0,1,.3.4v74.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-2" points="32.2 243 38.2 246.5 38.2 233.9 32.2 230.5 32.2 243" />
      <polygon class="cls-2" points="28.8 276.7 20.5 271.9 20.5 284.4 28.8 289.2 28.8 276.7" />
      <polygon class="cls-2" points="28.8 245 20.5 240.2 20.5 252 28.8 256.8 28.8 245" />
      <polygon class="cls-2" points="32.2 262.8 32.2 274.7 38.2 278.2 38.2 266.3 32.2 262.8" />
      <polygon class="cls-2" points="32.2 247 32.2 258.8 38.2 262.3 38.2 250.4 32.2 247" />
      <polygon class="cls-2" points="38.2 282.1 32.2 278.6 32.2 291.1 38.2 294.6 38.2 282.1" />
      <polygon class="cls-2" points="17.1 269.9 11 266.4 11 278.9 17.1 282.4 17.1 269.9" />
      <polygon class="cls-2" points="17.1 250.1 17.1 238.2 11 234.7 11 246.6 17.1 250.1" />
      <polygon class="cls-2" points="28.8 260.8 20.5 256 20.5 267.9 28.8 272.7 28.8 260.8" />
      <polygon class="cls-2" points="17.1 266 17.1 254 11 250.6 11 262.5 17.1 266" />
      <polygon class="cls-2" points="20.5 223.7 20.5 236.2 28.8 241 28.8 228.5 20.5 223.7" />
      <polygon class="cls-2" points="11 230.8 17.1 234.3 17.1 221.7 11 218.2 11 230.8" />
      <path
        d="M29.3,291.1l.2.3,2.4,1.4h.4l6.7,3.8h.2s.2,0,.2-.1a.4.4,0,0,0,.2-.4V283a.3.3,0,0,1,.1-.2V280c0-.1,0-.2-.1-.2V264c0-.1,0-.2-.1-.2V251.3a.3.3,0,0,1,.1-.2v-2.8c0-.1,0-.2-.1-.2V234.6a.5.5,0,0,0-.2-.4l-6.8-3.9c0-.1-.1-.2-.2-.3L30,228.6h-.4l-8.7-5-.2-.3L18.3,222H18L11.3,218h-.5a.4.4,0,0,0-.2.4v16.3c0,.1,0,.2.1.2v15.6c0,.1,0,.2.1.2v15.6c0,.1,0,.2.1.2V280a.5.5,0,0,0,.2.4l6.8,3.9.2.3,2.4,1.4h.4Zm-10.7-7.2V271.3l1.4.8v12.6ZM20,223.8v12.7l-1.4-.8V223Zm11.7,6.7v12.7l-1.4-.8V229.7Zm-1.4,60.2V278.1l1.4.8v12.6Zm2.4-11.3,6,3.5v12.5l-6-3.5Zm6.1,2.4L11.5,266v-1.7l27.3,15.8Zm0-33.3v1.7L11.5,234.4v-1.6ZM21,241l8.3,4.8v11.9L21,252.9Zm9.3,5.4,1.4.8V259l-1.4-.8Zm-10.3-6v11.9l-1.4-.8V239.6Zm-8.5,8.1,27.3,15.8V266L11.5,250.2Zm9.5,8.3,8.3,4.8v11.9L21,268.7Zm9.3,5.4,1.4.8v11.9l-1.4-.8Zm-10.3-6v11.9l-1.4-.8V255.4Zm12.7,19.3V263.6l6,3.5V279Zm0-15.9V247.7l6,3.5V263ZM17.6,239v11.9l-6-3.5V235.5Zm0,15.8v11.9l-6-3.5V251.3ZM21,272.7l8.3,4.8V290L21,285.2Zm17.7-25.4-6-3.5V231.3l6,3.5Zm-9.4-5.5L21,237V224.5l8.3,4.8ZM17.6,222.5V235l-6-3.5V219Zm-6.1,44.7,6,3.5v12.5l-6-3.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="19.5 267.3 19.5 255.4 18.1 254.6 18.1 266.5 19.5 267.3" />
      <polygon class="cls-1" points="19.5 271.3 18.1 270.5 18.1 283.1 19.5 284 19.5 271.3" />
      <polygon class="cls-1" points="19.5 251.5 19.5 239.6 18.1 238.8 18.1 250.7 19.5 251.5" />
      <polygon class="cls-1" points="18.1 234.8 19.5 235.7 19.5 223 18.1 222.2 18.1 234.8" />
      <polygon class="cls-1" points="31.2 278.1 29.8 277.3 29.8 289.9 31.2 290.7 31.2 278.1" />
      <polygon class="cls-1" points="31.2 262.2 29.8 261.4 29.8 273.3 31.2 274.1 31.2 262.2" />
      <polygon class="cls-1" points="31.2 246.4 29.8 245.6 29.8 257.4 31.2 258.2 31.2 246.4" />
      <polygon class="cls-1" points="29.8 241.6 31.2 242.4 31.2 229.7 29.8 228.9 29.8 241.6" />
      <polygon class="cls-1" points="11 231.9 11 233.5 38.3 249.3 38.3 247.7 11 231.9" />
      <polygon class="cls-1" points="38.3 265.1 38.3 263.5 11 247.7 11 249.4 38.3 265.1" />
      <polygon class="cls-1" points="11 263.6 11 265.2 38.3 281 38.3 279.4 11 263.6" />
      <path
        d="M10.1,196.8l.9.5v3.1c0,.2.1.3.3.4l.6.3h.5a.4.4,0,0,0,.2-.4v-2.5l.3.2h.2v3.1a.5.5,0,0,0,.2.4l2.5,1.5h.4l.2.3,2.4,1.3H19a.2.2,0,0,0,.2.2l2.5,1.5h.4l.2.2.6.3h.5a.4.4,0,0,0,.2-.4v-.7h.2a1.2,1.2,0,0,0,1.3.1h0v2c0,.2.1.3.3.4l.6.3h.5a.4.4,0,0,0,.2-.4V208l.6.3v1.5c0,.2.1.3.3.4l.6.3h.5c.1-.1.2-.2.2-.3a3.5,3.5,0,0,0,1.5,1.7l1,.3.6-.2.3-.2v.8a.5.5,0,0,0,.3.5l.6.3h.5a.5.5,0,0,0,.2-.4v-.4l.6,1.6a.2.2,0,0,0,.2.2l.6.4h.5a.5.5,0,0,0,.2.4l2.5,1.5h.3c.1,0,.2,0,.2-.1a.4.4,0,0,0,.2-.4v-.6a.5.5,0,0,0-.2-.4l-.7-.4h.4a.5.5,0,0,0,.3-.4v-.6a.5.5,0,0,0-.2-.4H39a.4.4,0,0,0,.2-.4v-.5a.5.5,0,0,0-.2-.4l-2.5-1.5H36a.5.5,0,0,0-.2-.4l-.5-.3a.5.5,0,0,0-.5,0,.5.5,0,0,0-.3.4v.4l-.6-1.6-.2-.3-.7-.3h-.5l-.2.3a3.5,3.5,0,0,0-1.5-1.7h0a1.5,1.5,0,0,0-1.7-.1l-.3.2v-.8a.5.5,0,0,0-.2-.4l-.6-.4h-.5a.5.5,0,0,0-.3.4v.7l-.6-.4V205a.5.5,0,0,0-.2-.4l-.6-.4h-.6a3.5,3.5,0,0,0-1-1.1h0l-1.5-.9a.3.3,0,0,0-.4,0c0-.1-.1-.2-.2-.3l-2.5-1.4h-.5a.4.4,0,0,0-.2.4v2.5l-1.2-.7v-3.1c0-.2-.1-.3-.3-.4l-.6-.3h-.3l-.2-.3-2.5-1.5h-.4l-2.8-1.7a.5.5,0,0,0-.5,0,.5.5,0,0,0-.3.4v.7Zm27.6,17.5h0l.8.5Zm-6.6-3.7a2,2,0,0,1-.8-1.7c0-.4.1-.5.1-.5h.2a2,2,0,0,1,.8,1.7c0,.4-.1.5-.1.5Zm-7.4-6,.4.4-.5-.3Zm-1.6-1.1h0Zm-1.5.9h0l1,.5h.5v.3ZM14.7,201h0l1.1.6h.4v.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M1.8,182.1v.2l.2.4,46.7,27.2c2.8-1.4,31.8-18.3,47.9-27.6l-46.9-27-.2-.2h0c-.1,0-7.5-2-23.7,7.3S2.8,180.8,1.8,182.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M98.1,182.2h0c0-.3-.1-.5-.4-.5h-.2L50.3,154.5a.4.4,0,0,0-.3-.4h-.6c-1.3-.3-8.9-1.4-24.2,7.5S1.4,180.8.8,181.7a.6.6,0,0,0-.3.6v5.2a1.2,1.2,0,0,0,.7,1.1l3,1.7v7.8l-1.8-1a.6.6,0,0,0-.8,0,.8.8,0,0,0-.4.7v83.9a.5.5,0,0,0,.2.4l21.7,12.5,19.3,11.1h0l1.2.7h0l5.3,3.1h.2s.2,0,.2-.1l5.3-3.1h0l.7-.4,41.6-24a.4.4,0,0,0,.2-.4V197.8h0a1,1,0,0,0-.5-.7c-.1,0-.4-.1-.6.1l-1.6,1v-8.3l3.2-1.8a.5.5,0,0,0,.3-.4l.2-5.4ZM2.3,198l46.4,26.8.2.3V308l-4.4-2.5V229.8a.5.5,0,0,0-.2-.4L6.5,207.6H6a.4.4,0,0,0-.2.4v75.1l-3.4-2V198Zm-.7-10.6v-3.8l46.6,27.1v3.7L1.8,187.6ZM49.5,155h0l.2.2,46.9,27c-16.1,9.3-45.1,26.2-47.9,27.6L2,182.7l-.2-.4a.3.3,0,0,0-.1-.2c1-1.3,8.8-11,24.1-19.8S49.4,154.9,49.5,155Zm7.3,63.9V213l33.8-19.5v5.9Zm34.5-26.7h-.5L56,212.2a.4.4,0,0,0-.2.4v7.1a.5.5,0,0,0,.2.4h0L52.7,222v-8.5l40.8-23.3v8.3l-2,1.2h0v-7.1C91.6,192.4,91.5,192.2,91.3,192.2ZM42.1,218.9,8.3,199.4v-5.9L42.1,213Zm.7,1.3a.4.4,0,0,0,.2-.4v-7.1h0l2.9,1.7v7.8l-3.1-1.9Zm4.2-5.4,1.5.9H49v8l-1.9-1.1v-7.9Zm2.9.4,1.9-1.1v8.6l-1.9,1.1ZM7.6,192.1H7.5a.4.4,0,0,0-.2.4v7.1h0l-2-1.2v-7.8Zm35.8,38.4c0-.2-.1-.3-.3-.4L7.7,209.6H7.2a.4.4,0,0,0-.2.4v73.7H6.8V208.8l36.8,21.3v74.8h-.2ZM7.9,284.3V210.9l34.4,19.9v73.4Zm84.2-.6H92V210.1a.5.5,0,0,0-.2-.4h-.5L55.8,230.1a.5.5,0,0,0-.3.4v74.3h-.1V230.1l36.8-21.3v74.9Zm-2-36.7h0c.1,0,.4.4.4,1.4a4.2,4.2,0,0,1-1,3c-.1,0-.4-.5-.4-1.5A3.8,3.8,0,0,1,90.1,247ZM56.4,230.8l34.5-19.9v35.4l-.3-.3a1.1,1.1,0,0,0-1.1,0c-.6.3-.9,1.1-1.2,1.9v-.4c0-.1,0-.2-.1-.2V231.8c0-.1,0-.2-.1-.2V218.2a.5.5,0,0,0-.2-.4.5.5,0,0,0-.5,0l-6.8,3.9h-.3L78,223c-.1.1-.2.2-.2.3l-8.7,5h-.3l-2.5,1.4-.2.3-6.8,3.9a.5.5,0,0,0-.3.4v16.5c0,.1,0,.2.1.2v12.5a.3.3,0,0,1-.1.2v2.8c0,.1,0,.2.1.2v15.6c0,.1,0,.2.1.2v13.3a.5.5,0,0,0,.2.4h.2c.1,0,.2,0,.2-.1l6.7-3.8h.3l2.5-1.4.2-.3,8.7-5h.4l2.4-1.4c.1-.1.2-.1.2-.2l6.9-4a.5.5,0,0,0,.3-.4V266.1a.3.3,0,0,1,.1-.2v-2.8c0-.1,0-.2-.1-.2v-12a1.5,1.5,0,0,0,.7,1h.5l.6-.2a4.5,4.5,0,0,0,.9-1v33.1L56.4,303.8Zm22.4,54V272.2l1.4-.8V284Zm-9.3,5.1V277.4l8.2-4.7v12.5Zm-2.4,1.6V278.9l1.5-.9v12.7ZM60,295.4V282.9l6-3.5v12.5Zm8.5-65.7v12.7l-1.5.9V230.6Zm9.3-5.2V237l-8.2,4.7V229.2Zm2.4-1.5v12.7l-1.4.8V223.8Zm7.1-4v12.5L81.2,235V222.5ZM60,281.8v-1.7l27.4-15.8V266Zm8.5-7.7L67,275V263l1.5-.9Zm1-12.5,8.2-4.7v11.9l-8.2,4.7Zm9.3-5.3,1.4-.8v11.9l-1.4.8ZM60,265.9v-1.7l27.4-15.8v1.7Zm18.8-25.5,1.4-.8v11.9l-1.4.8Zm-1,12.5-8.2,4.7V245.7l8.2-4.8Zm-9.3,5.3-1.5.9V247.2l1.5-.9Zm18.8-10.8-6.1,3.5V239l6.1-3.5Zm.1-14.7v1.6L60,250.1v-1.7ZM60,251.2l6-3.5v11.9l-6,3.5Zm0,15.9,6-3.5v11.9L60,279Zm27.3-3.8-6.1,3.5V254.9l6.1-3.5ZM66.1,243.8l-6,3.5V234.8l6-3.5Zm15.1,26.9,6.1-3.5v12.5l-6.1,3.5Zm15.3,10.4-3.5,2V208a.5.5,0,0,0-.2-.4h-.5L54.5,229.4a.4.4,0,0,0-.2.4v75.7L49.9,308V225.1l.2-.2L96.5,198Z"
        transform="translate(-0.5 -0.8)"
      />
    </g>
    <g id="BigBen">
      <path
        class="cls-1"
        d="M159.4,347.2h-.2s-.2,0-.2-.1l-47.8-27.6v1.8l48,27.8,48-27.8v-1.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M154,339.3h-.5l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V293.6l-.4-.2v40.1a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V292.3c0-.1.1-.3.1-.4l-.5-.3v43.1a1.5,1.5,0,0,1-.3.8h-.8L146,335a1.4,1.4,0,0,1-.7-1.3V289.9l-.4-.2v40a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V288.5a.8.8,0,0,1,.1-.4l-.6-.3V331a1.5,1.5,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V286.1l-.3-.2V326a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V285c0-.1.1-.2.1-.4l-.6-.3v43.1a1.2,1.2,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V282.6l-.5-.3v40a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V281.1a.8.8,0,0,1,.1-.4l-.4-.2v43.1a1.2,1.2,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V278.8l-.4-.2v40.1a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V277.5c0-.1.1-.3.1-.4l-.6-.3v43.1a1.2,1.2,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V275.1h-.1v45L154,340v-.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M124,317.8v.2l.5.3V278.6a1.3,1.3,0,0,0-.3-.7l-.4-.2v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M130.3,321.4a.3.3,0,0,0,.1.2l.5.3V282.2a2.1,2.1,0,0,0-.2-.6l-.4-.2v40Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M136.9,325.2a.3.3,0,0,0,.1.2l.5.3V286a1.7,1.7,0,0,0-.3-.7l-.4-.2v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M149.7,332.6v.2l.5.3V293.3a2.1,2.1,0,0,0-.2-.6l-.4-.2v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M143.3,328.8v.2l.5.3V289.6a4.1,4.1,0,0,0-.2-.7l-.4-.2v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M121.5,319.7V276.3l-1-.6v43.1c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M128,323.4V280l-1-.6v43.1c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M147.3,334.5V291l-1-.6v43.2c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M134.4,327.1V283.7l-1-.6v43.1c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M140.8,330.8V287.3l-1-.6v43.2c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M153.7,338.2V294.8l-1-.6v43.2c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M199.5,274.6l-.9.5v43.8a1.4,1.4,0,0,1-.7,1.3l-1.1.6H196c-.2-.1-.3-.3-.3-.8V276.9l-.5.3a.4.4,0,0,1,.1.3v40.2a1.5,1.5,0,0,1-.6,1.1l-.9.5H193a.8.8,0,0,1-.4-.7V278.7l-.4.2v43.7a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V280.6l-.4.2h0a.3.3,0,0,0,.1.2v40.2a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V282.3l-.5.3v43.8a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V284.4l-.5.3c0,.1.1.2.1.3v40a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V286l-.4.2V330a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V288l-.5.3h.1v40.4a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7v-40l-.4.2v43.8a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V291.7l-.5.3a.8.8,0,0,1,.1.4v40a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V293.4l-.4.2v43.8a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.5v.6l35.4-20.5V274.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M194.2,317.6v-40l-.4.2a2.1,2.1,0,0,0-.2.6V318l.5-.3C194.2,317.8,194.2,317.7,194.2,317.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M187.9,321.3v-40l-.4.2a3.9,3.9,0,0,0-.2.6v39.6l.5-.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M181.4,325V285.1l-.4.3a2.1,2.1,0,0,0-.2.6v39.6l.5-.3C181.3,325.2,181.4,325.1,181.4,325Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M168.6,332.4v-40l-.4.2-.2.6v39.6l.5-.3C168.5,332.6,168.6,332.5,168.6,332.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M175,328.8v-40l-.4.2a1.6,1.6,0,0,1-.3.6v39.6l.5-.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M197.6,275.7l-1,.6v43.5l.8-.5h.1a1,1,0,0,0,.1-.3V275.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M190.2,323.4l.8-.5h.1V279.5l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M170.9,334.5l.8-.5h.1a1,1,0,0,0,.1-.3V290.5l-1,.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M183.8,327.1l.8-.5h.1V283.1l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M177.3,330.9l.8-.5h.1V286.9l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M165.3,337.8h0a.5.5,0,0,0,.2-.4V294.2l-1,.6v43.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon
        class="cls-1"
        points="159.8 296.4 159.1 296.8 159.1 341.9 159.1 342.8 159.1 343.7 160.1 343.1 159.8 296.4"
      />
      <polygon
        class="cls-1"
        points="157.1 343.1 158.1 343.7 158.1 342.8 158.1 341.9 158.1 296.8 157.4 296.4 157.1 343.1"
      />
      <polygon class="cls-1" points="156.1 342.8 156.4 295.8 154.5 294.8 154.5 342.4 156.1 342.8" />
      <polygon class="cls-1" points="117.9 273.6 117.1 273.2 117.1 319.7 117.9 319.2 117.9 273.6" />
      <polygon class="cls-1" points="116.1 272.6 115.3 272.2 115 319 116.1 319.7 116.1 272.6" />
      <polygon class="cls-1" points="200.9 272.7 200 273.2 200 318.8 200.9 319.2 200.9 272.7" />
      <polygon class="cls-1" points="202.6 271.7 201.9 272.2 201.9 319.2 203.1 318.5 202.6 271.7" />
      <polygon class="cls-1" points="205.8 269.9 203.6 271.2 204.1 318.2 205.8 317.8 205.8 269.9" />
      <path
        class="cls-1"
        d="M119.4,267.8,154,287.7V287h-.5l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V241.3l-.4-.2v40a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V240a.8.8,0,0,1,.1-.4l-.5-.3v43.1a1.5,1.5,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V237.6l-.4-.2v40.1a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V236.3a.6.6,0,0,1,.1-.4l-.6-.3v43.1a1.5,1.5,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V233.8l-.3-.2v40.1a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V232.5a4.3,4.3,0,0,0,.1-.5l-.6-.3V275a1.2,1.2,0,0,1-.3.8h-.7l-1.1-.7a1.4,1.4,0,0,1-.7-1.3V230.1l-.5-.3V270a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V228.8c0-.1.1-.3.1-.4l-.4-.2v43.1a1.2,1.2,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V226.5l-.4-.2v40.1a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V224.8l-.6-.3v43.1a1.5,1.5,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V222.7h-.1v45.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M124,265.4a.3.3,0,0,0,.1.2l.5.3V226.2a1.7,1.7,0,0,0-.3-.7l-.4-.2v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M130.3,269.1v.2l.5.3V229.9a1.7,1.7,0,0,0-.3-.7l-.4-.2v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M136.9,272.9a.3.3,0,0,0,.1.2l.5.3V233.6a2.1,2.1,0,0,0-.2-.6l-.4-.2v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M149.7,280.2a.3.3,0,0,0,.1.2l.5.3V240.9l-.2-.5-.5-.3v40.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M143.3,276.6v.2l.5.3V237.3a3.9,3.9,0,0,0-.2-.6l-.4-.3v40.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M121.5,267.4V223.9l-1-.6v43.2a.4.4,0,0,0,.1.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M128,271V227.6l-1-.6v43.1c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M147.3,282.2V238.8l-1-.6v43.1c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M134.4,274.8V231.4l-1-.6V274c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M140.8,278.5V235l-1-.6v43.2c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M153.7,285.9V242.5l-1-.6v43.2c0,.2.1.3.1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M199.5,222.3l-.9.5v43.7a1.4,1.4,0,0,1-.7,1.3l-1.1.6H196c-.2-.1-.3-.3-.3-.8V224.5l-.5.3a.4.4,0,0,1,.1.3v40.2a1.5,1.5,0,0,1-.6,1.1l-.9.5H193a.8.8,0,0,1-.4-.7v-40l-.4.2v43.8a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V228.2l-.4.2v40.5a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V229.9l-.5.3v43.7a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V231.9l-.6.3a.6.6,0,0,1,.1.4v40.1a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V233.7l-.4.2v43.7a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V235.6l-.5.3a.4.4,0,0,1,.1.3v40.1a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V237.3l-.4.2v43.8a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V239.3l-.5.3h0a.3.3,0,0,0,.1.2v40.2a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V241.1l-.4.2V285a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.5v.6l35.4-20.4V222.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M193.6,226.2v39.6l.5-.3c.1,0,.1-.1.1-.2v-40h0l-.4.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M187.9,268.9V229l-.4.3a2.1,2.1,0,0,0-.2.6v39.6l.5-.3A.4.4,0,0,0,187.9,268.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M181.4,272.7v-40l-.4.3-.2.6v39.6l.5-.3A.3.3,0,0,0,181.4,272.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M168.6,280.1v-40l-.4.2-.2.6v39.6l.5-.3C168.5,280.3,168.6,280.2,168.6,280.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M175,276.4V236.5l-.4.3a2.1,2.1,0,0,0-.2.6V277l.5-.3C174.9,276.6,175,276.5,175,276.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M197.6,223.4l-1,.6v43.4l.8-.5h.1V223.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M190.2,271.1l.8-.5h.1V227.1l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M170.9,282.3l.8-.5h.1a1,1,0,0,0,.1-.3V238.3l-1,.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M183.8,274.8l.8-.5h.1a1,1,0,0,0,.1-.3V230.8l-1,.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M177.3,278.5l.8-.5h.1a1,1,0,0,0,.1-.3V234.5l-1,.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M165.3,285.5c.1,0,.1-.1,0,0a.5.5,0,0,0,.2-.4V241.9l-1,.6v43.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon
        class="cls-1"
        points="160.1 290.8 159.8 244.2 159.1 244.5 159.1 283.5 159.1 283.7 159.1 289.5 159.1 290.4 159.1 291.4 160.1 290.8"
      />
      <polygon
        class="cls-1"
        points="158.1 290.4 158.1 289.5 158.1 283.7 158.1 283.5 158.1 244.5 157.4 244.2 157.1 290.8 158.1 291.4 158.1 290.4"
      />
      <polygon class="cls-1" points="154.5 290.1 156.1 290.5 156.4 243.6 154.5 242.5 154.5 290.1" />
      <polygon class="cls-1" points="117.9 266.9 117.9 221.3 117.1 220.8 117.1 267.4 117.9 266.9" />
      <polygon class="cls-1" points="115 266.8 116.1 267.4 116.1 220.2 115.3 219.8 115 266.8" />
      <polygon class="cls-1" points="200.9 220.4 200 220.9 200 266.5 200.9 266.9 200.9 220.4" />
      <polygon class="cls-1" points="202.6 219.4 201.9 219.8 201.9 267 203.1 266.3 202.6 219.4" />
      <path
        class="cls-1"
        d="M119.4,215.4,154,235.3v-.7h-.5l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V195.7l-.4-.2v33.3a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V193.9l-.4-.2V230a1.5,1.5,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V192l-.4-.2V225a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V190.2l-.5-.3v36.3a1.2,1.2,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V188.2l-.3-.2v33.2a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V186.3l-.5-.3v36.2a1.2,1.2,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V184.2l-.5-.3v33.2a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V182.3l-.3-.2V219a1.5,1.5,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V181l-.4-.2v33.3a.7.7,0,0,1-.4.7h-.8l-.9-.6a1.4,1.4,0,0,1-.6-1.1V179.2l-.5-.3v36.3a1.5,1.5,0,0,1-.3.8h-.8l-1.1-.6a1.4,1.4,0,0,1-.7-1.3V177.2h-.1v38.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M124,213.2a.3.3,0,0,0,.1.2l.5.3V180.2l-.6-.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M130.3,216.7a.3.3,0,0,0,.1.2l.5.3V183.8l-.6-.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M136.9,220.6v.2l.5.3V187.7l-.6-.4Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M150.3,228.5V195l-.6-.4v33.6Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M143.3,224.2a.3.3,0,0,0,.1.2l.5.3V191.3l-.6-.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M120.5,214.2c0,.2.1.3.1.4l.9.5V178.5l-1-.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M127,217.9c0,.2.1.3.1.4l.9.5V182.2l-1-.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M146.3,192.7V229c0,.2.1.3.1.4l.9.5V193.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M133.4,221.6c0,.2.1.3.1.4l.9.5V185.9l-1-.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M139.8,225.3c0,.2.1.3.1.4l.9.5V189.6l-1-.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M152.7,232.7c0,.2.1.3.1.4l.9.5V197l-1-.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M166.6,195.8v37a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.5v.6L199.7,215V176.8l-.9.5v37a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V179l-.4.2V213a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V180.8l-.4.2v36.9a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V182.7l-.3.2v33.8a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V184.5l-.5.3v37a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V186.6l-.5.3v33.7a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V188.4l-.4.2v36.9a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V190.4l-.4.2v33.7a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V192.1l-.4.2v36.9a1.4,1.4,0,0,1-.7,1.3l-1.1.6h-.8c-.2-.1-.3-.3-.3-.8V194l-.4.2v33.7a1.5,1.5,0,0,1-.6,1.1l-.9.5h-.8a.8.8,0,0,1-.4-.7V195.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M193.6,213.5l.5-.3c.1,0,.1-.1.1-.2V179.8l-.6.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M187.3,217.2l.5-.3c.1,0,.1-.1.1-.2V183.5l-.6.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M180.7,220.9l.5-.3c.1,0,.1-.1.1-.2V187.3l-.6.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M168.6,227.8V194.7l-.6.4v33.3l.5-.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M174.3,224.7l.5-.3c.1,0,.1-.1.1-.2V191l-.6.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M196.6,215.1l.8-.5h.1V177.9l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M190.2,218.8l.8-.5h.1V181.6l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M170.9,229.9l.8-.5h.1V192.7l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M183.8,222.5l.8-.5h.1a1,1,0,0,0,.1-.3V185.3l-1,.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M177.3,226.2l.8-.5h.1V189l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M164.5,233.7l.8-.5h.1V196.5l-1,.6Z" transform="translate(-0.5 -0.8)" />
      <polygon
        class="cls-1"
        points="159.1 231.2 159.1 231.5 159.1 237.2 159.1 238 159.1 239.1 160.1 238.5 159.8 198.6 159.1 199 159.1 231.2"
      />
      <polygon
        class="cls-1"
        points="157.1 238.5 158.1 239.1 158.1 238 158.1 237.2 158.1 231.5 158.1 231.2 158.1 199 157.4 198.6 157.1 238.5"
      />
      <polygon class="cls-1" points="154.5 237.7 156.1 238.1 156.4 198.1 154.5 197 154.5 237.7" />
      <polygon class="cls-1" points="117.1 215.1 117.9 214.6 117.9 175.8 117.1 175.4 117.1 215.1" />
      <polygon class="cls-1" points="115 214.4 116.1 215.1 116.1 174.8 115.3 174.3 115 214.4" />
      <polygon class="cls-1" points="200 214.2 200.9 214.6 200.9 174.9 200 175.4 200 214.2" />
      <polygon class="cls-1" points="202.7 173.8 201.9 174.3 201.9 214.6 203.1 213.9 202.7 173.8" />
      <path
        class="cls-1"
        d="M153.5,192.5V190l-39.7-22.8-1.5,1.1h-.4l-2.4-1.4h-.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M207.3,167.7h-.6l-1.7-1L164.7,190v2.5l45.4-26.2h-.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="105.5 163.9 105.2 164 105.5 164.2 105.5 163.9" />
      <path
        class="cls-1"
        d="M155.5,193.6l3.6,2.1,3.6-2.1-1.1.3-2.2,1.2H159l-2.2-1.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="113.6 114.7 113.6 115.1 153 137.8 153 137.4 113.6 114.7" />
      <polygon class="cls-1" points="153 188 153 185.6 113.6 162.9 113.6 165.3 153 188" />
      <polygon class="cls-1" points="204.1 163 164.2 186 164.2 188 204.1 165.1 204.1 163" />
      <path class="cls-1" d="M164.7,138.2v.8l39.5-22.8h.3v-1Z" transform="translate(-0.5 -0.8)" />
      <polygon
        class="cls-1"
        points="159.1 178.8 159.1 179.1 159.1 187.3 159.1 187.6 159.1 191 159.1 191.8 159.1 193.1 160.4 192.3 160 139.9 159.1 140.4 159.1 178.8"
      />
      <polygon
        class="cls-1"
        points="156.8 192.3 158.1 193.1 158.1 191.8 158.1 191 158.1 187.6 158.1 187.3 158.1 179.1 158.1 178.8 158.1 140.4 157.2 139.8 156.8 192.3"
      />
      <polygon
        class="cls-1"
        points="161 139.3 161.4 192 163.2 191.5 163.2 185.7 163.2 139.1 163.2 138 161 139.3"
      />
      <polygon class="cls-1" points="154 191.5 155.8 192 156.2 139.3 154 138 154 191.5" />
      <polygon
        class="cls-1"
        points="112.1 166 112.6 165.6 112.6 162 112.6 115.3 112.6 114.1 112.1 113.8 112.1 166"
      />
      <polygon class="cls-1" points="110 112.6 109.6 165.3 111.1 166.2 111.1 113.2 110 112.6" />
      <polygon class="cls-1" points="106.5 164.5 108.6 165 109 112.1 106.5 110.6 106.5 164.5" />
      <polygon class="cls-1" points="205.1 165 206.1 165.6 206.1 113.2 205.1 113.8 205.1 165" />
      <polygon class="cls-1" points="207.1 112.7 207.1 165.6 208.5 164.8 208.1 112.1 207.1 112.7" />
      <polygon class="cls-1" points="211.6 110.1 209.1 111.5 209.5 164.4 211.6 163.9 211.6 110.1" />
      <path
        class="cls-1"
        d="M159.4,138H159l-53.7-31v2.1l54,31.1,53.9-31.1V107Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M214,106.2a.4.4,0,0,0-.1-.3h0a.1.1,0,0,0-.1-.1l-6.6-3.8V90.7l.6-.3a.4.4,0,0,0,.2-.4V87h-.1C193.5,74,178.8,45.8,178.7,45.5h0V34.1h-.1a.1.1,0,0,0-.1-.1c-6.6-5.8-18.8-32.2-19-32.5h-.8c-.1.3-12.4,26.7-19,32.5a.1.1,0,0,1-.1.1h-.1V45.4h0c-.1.3-14.7,28.5-29.2,41.1h-.1v2.9c0,.2.1.3.3.4l1.4.8v10.5l-7.2,4.1h-.1c0,.1-.1.2-.1.3h0v3.3a.5.5,0,0,0,.2.4l1.6.9v52.7l-1.6.9h-.1a.1.1,0,0,0-.1.1v.2h0v3.3a.5.5,0,0,0,.2.4l7.2,4.2v40.2l-1.3.8h-.2v3.2a.5.5,0,0,0,.2.4l1.3.8v47.1l-1.3.8a.1.1,0,0,0-.1.1h0c0,.1-.1.2-.1.3h0v2.9c0,.2.1.3.3.4l1.3.8v47l-1.3.8h-.2c0,.1-.1.2-.1.3v2.9a.5.5,0,0,0,.2.4l48.5,28h.2s.2,0,.2-.1l48.5-28a.4.4,0,0,0,.2-.4v-2.9a.4.4,0,0,0-.1-.3h-.2l-.6-.3V270.1l.6-.3a.4.4,0,0,0,.2-.4v-2.9h0a.4.4,0,0,0-.1-.3h-.1l-.6-.3V217.9l.6-.3a.4.4,0,0,0,.2-.4v-2.9a.4.4,0,0,0-.1-.3h-.2l-.6-.3v-41l6.4-3.7a.4.4,0,0,0,.2-.4v-3.3h0c0-.1,0-.2-.1-.2h-.2l-.7-.4V110.6l.7-.4a.4.4,0,0,0,.2-.4v-3.6Zm-1,3-53.9,31.1-54-31.1V107l53.7,31h.4l53.6-31v2.2ZM159.1,349.1l-48-27.8v-1.8l47.8,27.6h.4l47.8-27.6v1.8ZM105.7,164.8l.3-.2v.4Zm51-24.7-.3,52.7-1.8-.5V138.8Zm7-1.3v53.5l-1.8.5-.4-52.7ZM114.1,117l39.2,22.6v45.5l-39.2-22.6Zm89.9.6V163l-39.3,22.6V140.2Zm-39.3,71.2v-2l39.8-22.9v2Zm-50.6-22.7v-2.4l39.4,22.7v2.4Zm44.8,29h.5l2.2-1.2,1.1-.3-3.6,2.1-3.6-2.1,1.1.3ZM164.2,340v-.6h.5l1.1-.6a1.4,1.4,0,0,0,.7-1.3V293.6l.4-.2v39.9a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1v-40c0-.1-.1-.3-.1-.4l.5-.3v43.1a1.2,1.2,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V289.9l.4-.2v40a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V288.4h-.1l.5-.3v43.2a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V286.3l.4-.2V326a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V284.9a.4.4,0,0,0-.1-.3l.5-.3v43.1a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V282.5l.5-.3v39.9a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V281c0-.1,0-.2-.1-.2h0l.4-.2v43.1a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V278.8l.4-.2v39.9a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V277.4a.4.4,0,0,0-.1-.3l.5-.3V320a1.2,1.2,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V275.1l.9-.5v45Zm-46.6-19.5V274l.8.5V320ZM172,192.7v36.4a.4.4,0,0,1-.1.3h-.1l-.8.5V193.3Zm-4.1,2.3.6-.4v33.1a.3.3,0,0,1-.1.2l-.5.3Zm-.6,34.4h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V194.1l.4-.2v36.3a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V192.2l.4-.2v33.1a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V190.5l.4-.2v36.2a1.2,1.2,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V188.5l.4-.2v33.1a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V186.8l.5-.3v36.3a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3v-37l.5-.3v33.1a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V182.8l.3-.2V219a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V181l.4-.2v33.1a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V179.3l.4-.2v36.3a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3v-37l.9-.5V215l-35.4,20.4v-.6h.5l1.1-.6a1.4,1.4,0,0,0,.7-1.3v-37l.4-.2v33.1A1.3,1.3,0,0,0,167.3,229.4Zm7.7-5.3v.2l-.5.3V191.3l.6-.4Zm3.3,1.2a.4.4,0,0,1-.1.3h-.1l-.8.5V189.5l1-.6v36.4Zm3.1-4.9v.2l-.5.3V187.6l.6-.4Zm3.4,1.3a.4.4,0,0,1-.1.3h-.1l-.8.5V185.8l1-.6v36.5Zm3.1-5.1v.2l-.5.3V183.8l.6-.4Zm3.3,1.3a.4.4,0,0,1-.1.3H191l-.8.5V182.1l1-.6v36.4Zm3-4.9v.2l-.5.3V180.2l.6-.4Zm3.4,1.3a.4.4,0,0,1-.1.3h-.1l-.8.5V178.4l1-.6v36.5Zm0,104.6a.4.4,0,0,1-.1.3h-.1l-.8.5V276.2l1-.6v43.3Zm-4-38.4v-2a2.1,2.1,0,0,1,.2-.6l.4-.2v40a.3.3,0,0,1-.1.2l-.5.3V280.5Zm-6.3,3.7v-2l.2-.6.4-.2v40a.3.3,0,0,1-.1.2l-.5.3V284.2Zm-6.6,3.7v-2l.2-.6.4-.3v40a.3.3,0,0,1-.1.2l-.5.3V287.9Zm-6.4,3.8v-2a1.1,1.1,0,0,1,.3-.6l.4-.2v40a.3.3,0,0,1-.1.2l-.5.3V291.7Zm-6.4,3.6v-2a2.1,2.1,0,0,1,.2-.6l.4-.2v40a.3.3,0,0,1-.1.2l-.5.3V295.3Zm-15.2-1.1,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm-2.4-.9v39.8l-.5-.3V292.5l.4.2A2.1,2.1,0,0,1,150.3,293.3Zm-4-2.8,1,.6v43.5l-.9-.5a1,1,0,0,1-.1-.4Zm-2.4-.9v39.7l-.5-.3V288.7l.4.2A4.1,4.1,0,0,1,143.9,289.6Zm-4.1-2.8,1,.6v43.5l-.9-.5a1,1,0,0,1-.1-.4Zm-2.3-.8v39.7l-.5-.3a.3.3,0,0,1-.1-.2V285.1l.4.2A4.1,4.1,0,0,1,137.5,286Zm-4.1-2.9,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm-2.5-.9v39.7l-.5-.3a.3.3,0,0,1-.1-.2V281.3l.4.2A2.5,2.5,0,0,1,130.9,282.2Zm-3.9-2.8,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm-2.4-.8v39.7l-.5-.3V277.7l.4.2A2.5,2.5,0,0,1,124.6,278.6Zm-4.1-2.9,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm1-60.7-.9-.5a1,1,0,0,1-.1-.4V177.8l1,.6Zm-2-.8a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V179l.5.3v33.9a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V180.9l.4.2V218a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V182.8l.3.2v33.8a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V184.6l.5.3v36.9a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V186.7l.5.3v33.9a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V188.7l.3.2v36.9a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V190.6l.5.3v33.8a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V192.5l.4.2v36.9a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V194.4l.4.2V228a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V195.7l.4.2v36.9a1.4,1.4,0,0,0,.7,1.3l1.1.6h.5v.7l-34.6-19.9V177.4h.1v36.7Zm5.1-.5-.5-.3a.3.3,0,0,1-.1-.2V179.9l.6.4Zm3.4,5.1-.9-.5a1,1,0,0,1-.1-.4V181.6l1,.6Zm2.9-1.5-.5-.3V183.6l.6.4Zm3.5,5.1-.9-.5a1,1,0,0,1-.1-.4V185.2l1,.6Zm3.1-1.3-.5-.3V187.3l.6.4Zm3.3,5.1-.9-.5a1,1,0,0,1-.1-.4V189l1,.6Zm3.1-1.4-.5-.3V191l.6.4Zm3.4-31.5v36.6l-.9-.5a1,1,0,0,1-.1-.4V192.7Zm2.4,1.4.6.4v33.4l-.5-.3V194.7Zm-32.1,26.9.8.5v45.6l-.8.5Zm80,44.9a.4.4,0,0,1-.1.3h-.1l-.8.5V223.9l1-.6v43.2Zm-3.4-41.2v40.2l-.5.3V226.2a1.7,1.7,0,0,1,.3-.7l.3-.2Zm-6.9,6.5v-2a3.9,3.9,0,0,1,.2-.6l.4-.3V269l-.5.3V231.8Zm-6.6,3.8v-2l.2-.6.4-.2V273l-.5.3V235.6Zm-6.4,3.7v-2a3.9,3.9,0,0,1,.2-.6l.4-.3v40.1l-.5.3V239.3Zm-6.4,3.7v-2l.2-.6.4-.2v40a.3.3,0,0,1-.1.2l-.5.3V243Zm-15.2-1.1,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm-2.4-1v39.8l-.5-.3a.3.3,0,0,1-.1-.2V240.1l.5.3A4.3,4.3,0,0,0,150.3,240.9Zm-4-2.7,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm-2.4-.9v39.8l-.5-.3V236.5l.4.3A1.1,1.1,0,0,1,143.9,237.3Zm-4.1-2.8,1,.6v43.5l-.9-.5a1,1,0,0,1-.1-.4Zm-2.3-.9v39.8l-.5-.3a.3.3,0,0,1-.1-.2V232.7l.4.2Zm-4.1-2.8,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm-2.5-.9v39.7l-.5-.3V229l.4.2A2.5,2.5,0,0,1,130.9,229.9Zm-3.9-2.8,1,.6v43.4l-.9-.5a1,1,0,0,1-.1-.4Zm-2.4-.9V266l-.5-.3a.3.3,0,0,1-.1-.2V225.4l.4.2Zm-4.1-2.9,1,.6v43.5l-.9-.5V223.3Zm37.1,68.3.3-46.6.7.4v46.9Zm2-.4V245.3l.7-.4.3,46.6-1,.6ZM155,243.3l1.9,1.1-.3,46.9-1.6-.4V243.3Zm9.5-.8,1-.6v43.2a.4.4,0,0,1-.1.3h-.1l-.8.5Zm7.5-4.3v43.2a.4.4,0,0,1-.1.3h-.1l-.8.5V238.7Zm6.3-3.7v43.2a.4.4,0,0,1-.1.3h-.1l-.8.5V235.1Zm6.5-3.7V274a.4.4,0,0,1-.1.3h-.1l-.8.5V231.4Zm6.4-3.7v43.2a.4.4,0,0,1-.1.3H191l-.8.5V227.6Zm-71.7-4.4v43.8a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V224.5l.6.3a.8.8,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V226.3l.4.2v43.7a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V228.2l.4.2a.8.8,0,0,0-.1.4V269a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V229.9l.5.3v43.7a1.4,1.4,0,0,0,.7,1.3l1.1.7h.7c.2-.1.3-.3.3-.8V232l.6.3a.9.9,0,0,0-.1.5V273a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V233.9l.3.2v43.8a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V235.9l.6.3a.8.8,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V237.7l.4.2v43.7a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V239.6l.5.3a.6.6,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7v-40l.4.2v43.7a1.4,1.4,0,0,0,.7,1.3l1.1.6h.5v.7l-34.6-19.9.2-45.5Zm44.7,65V287h.5l1.1-.6a1.4,1.4,0,0,0,.7-1.3V241.3l.4-.2V281a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V239.9c0-.1,0-.2-.1-.2h0l.5-.3v43.1a1.2,1.2,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V237.5l.4-.2v39.9a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V236.2a.4.4,0,0,0-.1-.3l.5-.3v43.1a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V233.9l.4-.2v39.9a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V232.6c0-.1-.1-.2-.1-.4l.6-.3V275a1.2,1.2,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V230.2l.5-.3v39.9a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V228.7a.4.4,0,0,0-.1-.3l.4-.2v43.1a1.5,1.5,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V226.4l.4-.2v40a.7.7,0,0,0,.4.7h.8l.9-.5a1.1,1.1,0,0,0,.6-1.1V224.8l.5-.3v43.1a1.2,1.2,0,0,0,.3.8h.8l1.1-.6a1.4,1.4,0,0,0,.7-1.3V222.8l.9-.5v45Zm-3.6-48.4-1,.6v-40l.7-.4Zm-2-7.3v8l-1-.6.3-39.9.7.4Zm-1.7-33.1-.3,40.1-1.6-.4V197.8Zm43.6,68.4V221.7l.8-.5v46.5Zm-46.8-33.7-.9-.5a1,1,0,0,1-.1-.4V196.4l1,.6Zm-35.3-18.2-.8.5V176.2l.8.5Zm46.1,79.4,1-.6v43.2a.4.4,0,0,1-.1.3h-.1l-.8.5Zm7.5-4.3v43.2a.4.4,0,0,1-.1.3h-.1l-.8.5V291Zm6.3-3.7V330a.4.4,0,0,1-.1.3h-.1l-.8.5V287.3Zm6.5-3.7v43.2a.4.4,0,0,1-.1.3h-.1l-.8.5V283.6Zm6.4-3.7v43.1a.4.4,0,0,1-.1.3H191l-.8.5V279.9Zm10.2-64-.8-.5V176.1l.8-.5Zm-35.8,17.4a.4.4,0,0,1-.1.3h-.1l-.8.5V196.9l1-.6v36.5Zm-49.8-57.7.8.5v40.3l-1.1-.6Zm0,45.5.8.4v47.2l-1.1-.6Zm86.6,47.2V220.7l.8-.4.4,46.9Zm0-52.4V175.1l.8-.5.4,40.1ZM115.8,273l.8.4v47.1l-1.1-.6Zm3.6,2h0v43.8a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V276.8l.6.3a.8.8,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V278.6l.4.2v43.7a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V280.5l.4.2a.6.6,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7v-40l.5.3v43.7a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V284.3l.6.3a.8.8,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V286l.3.2V330a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V288l.6.3a.8.8,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7v-40l.4.2v43.8a1.4,1.4,0,0,0,.7,1.3l1.1.6h.8c.2-.1.3-.3.3-.8V291.9l.5.3a.8.8,0,0,0-.1.4v40.2a1.5,1.5,0,0,0,.6,1.1l.9.6h.8a.8.8,0,0,0,.4-.7V293.7l.4.2v43.7a1.4,1.4,0,0,0,.7,1.3l1.1.6h.5v.7l-34.6-20V275Zm39.2,22.6v47l-1-.6.3-46.7Zm1,46v-46l.7-.4.3,46.7-1,.6ZM201.4,320l-.8-.5V274l.8-.5ZM155,295.6l1.9,1.1-.3,46.9-1.6-.4V295.6ZM111.8,168.3h.4l1.5-1.1L153.4,190v2.5L109,166.8h.4ZM202.4,320V273l.8-.4.4,46.8ZM164.7,192.4V190l40.4-23.2,1.7,1h.5l2.5-1.5h.3ZM209,165.6l-1.4.8v-53l1-.6Zm-2.4.8-1-.6V114.6l1-.6Zm-2-50.2h-.3L164.7,139v-.8l39.8-23v1Zm-43.7,76.9-1.3.7V141.1l.9-.5Zm-2.3-13.5v14.2l-1.3-.7.3-52.5,1,.6Zm-5.1-41-39.4-22.7v-.3l39.4,22.7Zm-40.4-22.5v50.3l-.6.4V114.6l.6.3ZM111.6,167l-1.5-.9.4-52.7,1,.6v53Zm-2.1-54.1-.4,52.9-2.1-.5V111.4Zm96.8,205.7-1.7.4-.4-47,2.2-1.3v47.9Zm5.8-153.9-2.1.5-.3-52.9,2.5-1.4v53.8ZM142.6,37.4l1.1.6v9.3l-.9-.5a.8.8,0,0,1-.2-.5V37.4Zm32.2,9.7h0l-.9.5V38.1l1-.6v9.2A1,1,0,0,1,174.8,47.1Zm-28.2-7.4,1.1.6v9.3l-.9-.5a.8.8,0,0,1-.2-.5V39.7Zm12.3,6c.1,0,.1-.1,0,0Zm12,3.7h0l-.9.5V40.4l1-.6v9.3C171,49.2,171,49.4,170.9,49.4Zm-8.6-4.5,1-.6v9.2a1,1,0,0,1-.1.3h-.1l-.8.5V44.9Zm5.9-3.4.8-.5v9.2h0l-.8.5Zm-3,11-.9.5V43.6l.9-.5v9.4Zm1-9.9,1-.6v9.5H167l-.8.5V42.6Zm-15.4-.5,1.1.6V52l-.9-.5a.8.8,0,0,1-.2-.5V42.1Zm4,2.3,1.1.6v9.3l-.9-.5a.8.8,0,0,1-.2-.5V44.4Zm-6.1,5.5v-9l1,.6v9.4l-1.1-.6A.8.8,0,0,0,148.7,49.9Zm4.2,2.4v-9l.9.5v9.4l-1-.6C152.8,52.5,152.9,52.4,152.9,52.3Zm4,2.4v-9l1.6.9V56l-1.6-.9Zm2.5-8.2,1.8-1.1v9.3l-1.9,1.1V46.5ZM172,48.6V39.2l.8-.5V48Zm-27.3-1v-9l.9.5v9.4l-1-.6A.4.4,0,0,0,144.7,47.6Zm32.8-2.2-1.6,1V37l1.6-1Zm-.3-11.5L159.4,44.2V3.6C162.4,9.8,171.4,28.2,177.2,33.9ZM158.4,44.2,140.6,33.9c5.8-5.7,14.8-24.1,17.8-30.3Zm-16.8-7.4v9.4l-1.3-.7V36.1ZM158.4,57v57.2L111.2,86.9c13.4-12.1,26.7-36.8,28.7-40.5ZM110.9,87.9l47.8,27.6h.4l47.8-27.6v1.8l-48,27.7-48-27.7Zm4.7,5.6.9.5v13.1l-1.2-.7Zm6.1,3.5v12l-1.3-.8a1.1,1.1,0,0,1-.3-.7V96.1Zm76.1-.9v11.5a1.1,1.1,0,0,1-.3.7l-1.3.8v-12Zm4.4,10.6V93.5l.9-.5.3,13Zm-1,0-.8-.5V94.6l.8-.5Zm-1.8-.5-.6.3v-11l.6-.3Zm-4.2,2.5-2.8,1.6V99.2l2.8-1.6Zm-3.9,2.6a1.1,1.1,0,0,1-.3.7l-1.3.8v-12l1.7-1v11.5Zm-2.6,1.1L186,114V102.9l2.7-1.6Zm-3.8,2.6a1.1,1.1,0,0,1-.3.7l-1.3.8v-12l1.7-1V115Zm-2.6,1.1-2.7,1.6V106.6l2.7-1.6Zm-3.8,2.6a1.1,1.1,0,0,1-.3.7l-1.3.8v-12l1.7-1v11.5Zm-2.6,1.1-2.8,1.6V110.3l2.8-1.6Zm-3.9,2.6a1.1,1.1,0,0,1-.3.7l-1.3.8v-12l1.6-1Zm-2.6,1.2-2.7,1.6V114l2.7-1.6Zm-3.7,2.5a1.1,1.1,0,0,1-.3.7l-1.3.8v-12l1.7-1v11.5Zm-2.7,1.6v2.2l-1.6.4-.3-13,1.8-1.1v11.5Zm-2.6,2.9-1,.6V118.1l.7-.4Zm-2-1.3v1.9l-1-.6.3-12.8.7.4Zm-2,.9-1.6-.4V116.1l1.8,1.1Zm-2.5-2.6-1.3-.8a1.1,1.1,0,0,1-.3-.7V114.6l1.6,1Zm-2.7-2.4-2.8-1.6V112.4l2.8,1.6Zm-3.8-1.3-1.3-.8a1.1,1.1,0,0,1-.3-.7V110.8l1.6,1Zm-2.7-2.5-2.7-1.6V108.7l2.7,1.6Zm-3.7-1.2-1.3-.8a1.1,1.1,0,0,1-.3-.7V107.2l1.7,1v12Zm-2.7-2.5-2.8-1.6V105l2.8,1.6Zm-3.8-1.3-1.3-.8a1.1,1.1,0,0,1-.3-.7V103.4l1.6,1Zm-2.7-2.4-2.7-1.6V101.3l2.7,1.6Zm-3.7-1.2-1.3-.8a1.1,1.1,0,0,1-.3-.7V99.7l1.6,1Zm-2.6-2.5-2.7-1.6V97.6l2.7,1.6Zm-7.3-3.6-.7.4V94.6l.7.4Zm87.9-1.5-1.8.4L204,92.4l2-1.2v14ZM114.6,92.9l-.3,13.2-1.8-.4v-14Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M114.1,162.5l39.2,22.6V139.6L114.1,117Zm.7-43.5a.5.5,0,0,1,.2-.4h.5l1.7,1,33.4,19.3,1.8,1.1a.4.4,0,0,1,.2.4v42.9a.5.5,0,0,1-.2.4h-.3c-.1,0-.2,0-.2-.1l-1.8-1L115,162.3a.4.4,0,0,1-.2-.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M115.8,161.5l36,20.8V140.6l-1.6-1-33.4-19.3h0l-1-.6Zm34.3,3.5v14.6l-12.7-7.3a17.7,17.7,0,0,1-4.3-1.9,22.6,22.6,0,0,1-4.1-3l-11.7-6.8V146.7a24.9,24.9,0,0,1-.5-4.6,17.7,17.7,0,0,1,.5-4.1V122.5l13.5,7.8a17.2,17.2,0,0,1,3.7,1.7h0a20.5,20.5,0,0,1,3.5,2.5l12.1,7v13.2a26.4,26.4,0,0,1,.6,5.5A14.4,14.4,0,0,1,150.1,165Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M114.8,161.8a.5.5,0,0,0,.2.4l35.2,20.4,1.8,1h.5a.4.4,0,0,0,.2-.4V140.3a.5.5,0,0,0-.2-.4l-1.8-1.1-33.4-19.3-1.7-1h-.5a.4.4,0,0,0-.2.4v42.9Zm1-42,1,.6h0l33.4,19.3,1.6,1v41.7l-36-20.8V119.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-2"
        d="M148,160.3c0-9.5-6.7-21.1-14.9-25.9a12.6,12.6,0,0,0-6.3-1.9c-4.5,0-7.3,3.8-7.3,9.8,0,9.5,6.7,21.1,14.9,25.9a13.2,13.2,0,0,0,6.3,1.9C145.3,170.1,148,166.4,148,160.3ZM137.5,144l1.3-1.9a1.1,1.1,0,0,1,.7-.3.7.7,0,0,1,.5.4l.3.4h.1c.1.2.3.7,0,1l-1.3,1.9a.9.9,0,0,1-.6.3h-.1a.7.7,0,0,1-.5-.4l-.3-.4h-.1C137.4,144.8,137.1,144.4,137.5,144Zm-4.7-6.6c0-.4.2-.6.3-.6a.6.6,0,0,1,.7,0h0l.5.3a1.1,1.1,0,0,1,.5.9v3.2c0,.4-.2.6-.3.6h-.7l-.5-.3a1.1,1.1,0,0,1-.5-.9Zm-5.6-2a.5.5,0,0,1,.5-.3h.4a.9.9,0,0,1,.8.6h0l1.4,3.7a.9.9,0,0,1,0,.7.5.5,0,0,1-.5.3h-.4a1,1,0,0,1-.8-.5l-1.4-3.7A.6.6,0,0,1,127.2,135.4Zm-4.3,2.4.2-.3a.9.9,0,0,1,.7-.3.7.7,0,0,1,.5.4l2.4,3h.1c.1.2.3.7,0,1l-.2.3-.6.3h-.1a.7.7,0,0,1-.5-.4l-2.4-3h-.1A.7.7,0,0,1,122.9,137.8Zm-1.7,6.3v-.5a.6.6,0,0,1,.3-.6c.1-.1.3-.2.7,0h0l2.8,1.6a1.1,1.1,0,0,1,.5.9v.5c0,.4-.2.6-.3.6h-.7l-2.9-1.7A.9.9,0,0,1,121.2,144.1Zm4.8,8.4-2.4.2h0c-.6,0-.8-.4-.8-.6l-.3-.7a1.1,1.1,0,0,1,0-.8.5.5,0,0,1,.5-.3l2.4-.2h0c.6,0,.8.4.8.6h0l.3.6a1.1,1.1,0,0,1,0,.8A.7.7,0,0,1,126,152.5Zm3.7,5.3-1.3,1.9-.6.3h-.1a.7.7,0,0,1-.5-.4l-.3-.4h-.1c-.1-.2-.3-.7,0-1l1.3-1.9a1.1,1.1,0,0,1,.7-.3.7.7,0,0,1,.5.4l.3.4a.1.1,0,0,0,.1.1A.9.9,0,0,1,129.7,157.8Zm4.6,6.7c0,.4-.2.6-.3.6h-.6l-.5-.3a.9.9,0,0,1-.5-.9v-3.2c0-.4.2-.6.3-.6a.6.6,0,0,1,.7,0h0l.5.3a1.1,1.1,0,0,1,.5.9v3.2Zm1.7-7.6c-.7-.4-1.3-1.4-1.9-3.2l-1-.5h-.2l-1.1,1.2-.4.2h-.1c-.2,0-.3-.1-.4-.3a5.7,5.7,0,0,0-1.3-1.6c-.2-.1-.2-.3-.2-.5a4.4,4.4,0,0,0-.4-1.8c-.1-.2-.1-.4.1-.5l.5-.2,1.8.3h.2a1.1,1.1,0,0,1,.2-.6l-1.7-2.8c-.5-.1-1.3-.7-1.9-2.5s-1-3.5-1-3.5,0-.4.2-.5a.5.5,0,0,1,.6.1,34.8,34.8,0,0,1,2.5,2.6c1.3,1.4,1.3,2.5,1.2,2.9s1,1.9,1.7,3a3.4,3.4,0,0,1,1.2.6l4-1.2c4.8-1.6,5.4-1.2,5.7-1h.1a.4.4,0,0,1,.1.5c0,.2-.2.7-2.4,1.8h1.4c.6,0,.8.4.8.5h0l.3.6a1.1,1.1,0,0,1,0,.8.5.5,0,0,1-.5.3l-2.4.2h0c-.6,0-.8-.4-.8-.6l-.3-.7a.6.6,0,0,1-.1-.4l-.7.3-3.8,1.6h0v.3h0v.2c1.4,1.5,1.9,2.5,1.9,3.3a1.3,1.3,0,0,1-.4.9h-.6A.9.9,0,0,1,136,156.9Zm4,9.6a.5.5,0,0,1-.5.3h-.4a.9.9,0,0,1-.8-.6l-1.4-3.7a.9.9,0,0,1,0-.7.5.5,0,0,1,.5-.3h.4a1,1,0,0,1,.8.5h0l1.4,3.7A.9.9,0,0,1,140,166.5Zm4.2-2.4-.2.3-.6.3h-.1a.7.7,0,0,1-.5-.4l-2.4-3a.1.1,0,0,0-.1-.1c-.1-.2-.3-.7,0-1l.2-.3a.9.9,0,0,1,.7-.3.7.7,0,0,1,.5.4l2.4,3h.1C144.3,163.3,144.6,163.8,144.2,164.1Zm.8-5.1-2.9-1.7a1.1,1.1,0,0,1-.5-.9v-.5a.6.6,0,0,1,.3-.6c.1-.1.3-.2.7,0h0l2.8,1.6a1.1,1.1,0,0,1,.5.9v.5c0,.4-.2.6-.3.6H145Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M134,132.9a14.2,14.2,0,0,0-7.2-2.2c-5.5,0-9,4.5-9,11.5,0,10,7.1,22.3,15.7,27.3a14.2,14.2,0,0,0,7.1,2.2c5.5,0,9-4.5,9-11.5C149.8,150.3,142.7,138,134,132.9Zm-.1,36.1c-8.5-4.9-15.4-16.9-15.4-26.8,0-6.6,3.2-10.8,8.3-10.8a13.7,13.7,0,0,1,6.8,2.1c8.5,4.9,15.4,16.9,15.4,26.7,0,6.7-3.2,10.8-8.3,10.8A13,13,0,0,1,133.9,169Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M150.1,154.8V141.6l-12.1-7a28,28,0,0,0-3.5-2.5h0a23.9,23.9,0,0,0-3.7-1.7l-13.5-7.8v15.5a17.7,17.7,0,0,0-.5,4.1,24.9,24.9,0,0,0,.5,4.6v13.9l11.7,6.8a28.6,28.6,0,0,0,4.1,3,17.7,17.7,0,0,0,4.3,1.9l12.7,7.3V165a17.5,17.5,0,0,0,.6-4.8A20.3,20.3,0,0,0,150.1,154.8Zm-9.3,16.9a14.2,14.2,0,0,1-7.1-2.2c-8.7-5.1-15.7-17.3-15.7-27.3,0-7,3.5-11.5,9-11.5a14.8,14.8,0,0,1,7.2,2.2c8.7,5.1,15.7,17.3,15.7,27.3C149.8,167.2,146.2,171.7,140.8,171.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M149,160.3c0-9.9-6.9-21.8-15.4-26.7a13.7,13.7,0,0,0-6.8-2.1c-5,0-8.3,4.2-8.3,10.8,0,9.9,6.9,21.8,15.4,26.8a14,14,0,0,0,6.8,2.1C145.8,171.1,149,166.9,149,160.3Zm-14.6,7.9c-8.2-4.7-14.9-16.3-14.9-25.9,0-6.1,2.8-9.8,7.3-9.8a13.4,13.4,0,0,1,6.3,1.9c8.2,4.7,14.9,16.3,14.9,25.9,0,6.2-2.7,9.8-7.3,9.8A14.4,14.4,0,0,1,134.4,168.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M132,151.8l-.3-.8h-.4l-1.1-.2a5,5,0,0,1,.2,1.2,5,5,0,0,1,1,1.1l.7-.9h.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M135.7,151l3.6-1.5a20.7,20.7,0,0,0,3.6-1.7,29,29,0,0,0-4.1,1.1h0l-3.6,1.1A3.1,3.1,0,0,1,135.7,151Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M130.4,145.5h.2c0-.1,0-.2.1-.2s.3-.7-.9-2.1l-1.1-1.2a14.2,14.2,0,0,0,.5,1.6C129.7,145.4,130.4,145.5,130.4,145.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M135.2,153.5h0a5.1,5.1,0,0,0,1.2,2.6h.2V156C136.7,155.6,136.4,154.9,135.2,153.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M137.2,156.9a1.1,1.1,0,0,0,.4-.9c0-.8-.6-1.8-1.9-3.3v-.2h0v-.3h0l3.8-1.6.7-.3a.6.6,0,0,0,.1.4l.3.7c.1.1.3.6.8.6h0l2.4-.2a.5.5,0,0,0,.5-.3,1.1,1.1,0,0,0,0-.8l-.3-.6h0a1,1,0,0,0-.8-.5h-1.4c2.2-1.1,2.3-1.6,2.4-1.8a.7.7,0,0,0-.1-.5.1.1,0,0,0-.1-.1c-.2-.2-.9-.6-5.7,1l-4,1.2a3.4,3.4,0,0,0-1.2-.6l-1.7-3c.1-.5.1-1.5-1.2-2.9l-2.5-2.6a.7.7,0,0,0-.6-.1.4.4,0,0,0-.2.5s.3,1.2,1,3.5,1.4,2.3,1.9,2.5l1.7,2.8c-.1.2-.1.4-.2.6h-.2l-1.8-.3c-.2,0-.4,0-.5.2a.9.9,0,0,0-.1.5,4.4,4.4,0,0,1,.4,1.8.8.8,0,0,0,.2.5,4.6,4.6,0,0,1,1.3,1.6l.4.3h.1l.4-.2,1.1-1.2h.2l1,.5c.6,1.8,1.2,2.8,1.9,3.2l.7.2h.4Zm6.8-6.4Zm-2.3.2v-.3h1.9v.3Zm-5.1,5.4h-.2c-.3-.1-.7-.7-1.3-2.5h.1c1.2,1.4,1.5,2.1,1.5,2.4S136.7,156,136.6,156.1Zm-5.1-2.8a3.5,3.5,0,0,0-1-1.1,4.3,4.3,0,0,0-.2-1.2l1.1.2h.4l.3.8.4.6h-.1Zm7.3-4.4h0a22.9,22.9,0,0,1,4.1-1.1,25.6,25.6,0,0,1-3.6,1.7l-3.6,1.5a3.1,3.1,0,0,0-.5-1Zm-3.9,3.1a.8.8,0,0,1-.2.6c-.1.1-.4,0-.7-.1a3.2,3.2,0,0,1-1.4-2.4.8.8,0,0,1,.2-.6h.2l.5.2h0A2.8,2.8,0,0,1,134.9,152Zm-5.2-8.8c1.2,1.3,1,2,.9,2.1v.2h-.2s-.7-.1-1.3-1.8l-.5-1.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M133.5,149.7h0l-.5-.2h-.2a.8.8,0,0,0-.2.6,3.2,3.2,0,0,0,1.4,2.4.6.6,0,0,0,.7.1.8.8,0,0,0,.2-.6A2.8,2.8,0,0,0,133.5,149.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M133.4,141.5l.5.3h.7a.7.7,0,0,0,.3-.6V138a1.1,1.1,0,0,0-.5-.9l-.5-.3h0a.6.6,0,0,0-.7,0,.9.9,0,0,0-.3.6v3.2A.8.8,0,0,0,133.4,141.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M128.5,139.8a1,1,0,0,0,.8.5h.4a.5.5,0,0,0,.5-.3c.1-.2.2-.5,0-.7l-1.4-3.7h0c-.1-.1-.3-.6-.8-.6h-.4a.5.5,0,0,0-.5.3c-.1.2-.2.5,0,.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M122.9,138.9l2.4,3a1,1,0,0,0,.5.4h.1l.6-.3.2-.3c.3-.3.1-.8,0-1h-.1l-2.4-3a1,1,0,0,0-.5-.4.7.7,0,0,0-.7.3l-.2.3a.9.9,0,0,0,.1,1.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="124 144.7 121.7 143.3 121.7 143.3 124 144.7" />
      <path
        d="M124.9,146.7h.3a.9.9,0,0,0,.3-.6v-.5a1.1,1.1,0,0,0-.5-.9l-2.8-1.6h0a.6.6,0,0,0-.7,0,.7.7,0,0,0-.3.6v.5a1.1,1.1,0,0,0,.5.9l2.9,1.7Zm-2.7-2.6,2.4,1.4h0l-2.4-1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M126,151.5Z" transform="translate(-0.5 -0.8)" />
      <polygon class="cls-1" points="125 150.7 124.9 150.4 123 150.5 123.2 150.8 125 150.7" />
      <path
        d="M126.6,152.2a1.1,1.1,0,0,0,0-.8l-.3-.6h0c-.1-.1-.3-.6-.8-.6h0l-2.4.2a.5.5,0,0,0-.5.3.8.8,0,0,0,0,.8l.3.7c.1.1.3.6.8.6h0l2.4-.2Zm-1.2-1v.3h-1.9v-.3Zm.6.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M128.8,157.3h0l-.2-.2-1,1.5h0v.2Z" transform="translate(-0.5 -0.8)" />
      <path
        d="M129.6,156.7l-.3-.4a1,1,0,0,0-.5-.4.7.7,0,0,0-.7.3l-1.3,1.9c-.3.3-.1.8,0,1h.1l.3.4a1,1,0,0,0,.5.4h.1l.6-.3,1.3-1.9a.9.9,0,0,0-.1-1.1Zm-2,1.9,1-1.5v.2h0l-1,1.5v-.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M133.8,160.4l-.5-.3h0a.6.6,0,0,0-.7,0,.7.7,0,0,0-.3.6v3.2a1.1,1.1,0,0,0,.5.9l.5.3h.6a.9.9,0,0,0,.3-.6v-3.2A.8.8,0,0,0,133.8,160.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M138.7,162.1h0a.9.9,0,0,0-.8-.6h-.4a.5.5,0,0,0-.5.3c-.1.2-.2.5,0,.7l1.4,3.7c.1.1.3.6.8.6h.4a.5.5,0,0,0,.5-.3c.1-.2.2-.5,0-.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M144.2,163l-2.4-3a1,1,0,0,0-.5-.4.7.7,0,0,0-.7.3l-.2.3c-.3.3-.1.8,0,1a.1.1,0,0,0,.1.1l2.4,3a1,1,0,0,0,.5.4h.1l.6-.3.2-.3c.3-.3,0-.8-.1-1.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="142.1 155.6 144.5 157 144.5 157 142.1 155.6" />
      <path
        d="M146,158.4v-.5a1.1,1.1,0,0,0-.5-.9l-2.8-1.6h0a.6.6,0,0,0-.7,0,.7.7,0,0,0-.3.6v.5a1.1,1.1,0,0,0,.5.9l2.9,1.7h.7C145.8,158.9,146,158.7,146,158.4Zm-1-.6-2.4-1.4h0l2.4,1.4Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="141 149.6 141.2 149.9 143 149.8 142.9 149.5 141 149.6" />
      <path class="cls-1" d="M144,150.5Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M138.3,144.5h0l.2.2,1-1.5h-.1Z" transform="translate(-0.5 -0.8)" />
      <path
        d="M137.5,145.1l.3.4a1,1,0,0,0,.5.4h.1a.9.9,0,0,0,.6-.3l1.3-1.9c.3-.3.1-.8,0-1h-.1l-.3-.4a1,1,0,0,0-.5-.4.7.7,0,0,0-.7.3l-1.3,1.9c-.3.4,0,.8.1,1.1Zm2-1.9-1,1.5v-.2h0l1-1.5v.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M164.7,185.6,204,163V117.6l-39.3,22.6Zm.9-45.2,1.7-1h0l33.4-19.3,1.8-1h.5a.4.4,0,0,1,.2.4v42.9c0,.2-.1.4-.3.4l-1.8,1-35.2,20.3h-.4a.4.4,0,0,1-.2-.4V140.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M202.4,162.1V120.4l-1.1.6-33.4,19.3h0l-1.5.9v41.7Zm-34.4,18V165.4a21.4,21.4,0,0,1-.5-4.5,31.4,31.4,0,0,1,.5-5.1V142l12.7-7.3,3-2.1A16.6,16.6,0,0,1,187,131l13.7-7.9v14.7a18.8,18.8,0,0,1,.6,4.9,25.7,25.7,0,0,1-.6,5.5v12.9l-11.1,6.4a28,28,0,0,1-4.5,3.4,16.4,16.4,0,0,1-4.8,2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M165.4,140.8v42.9a.5.5,0,0,0,.2.4h.4l35.2-20.3,1.8-1a.5.5,0,0,0,.3-.4V119.5a.5.5,0,0,0-.2-.4h-.5l-1.8,1-33.4,19.3h0l-1.7,1C165.5,140.5,165.4,140.6,165.4,140.8Zm1,.3,1.5-.9h0l33.4-19.3,1.1-.6V162l-36,20.7Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-2"
        d="M198.6,142.6c0-6-2.8-9.7-7.3-9.7a13.7,13.7,0,0,0-6.3,1.9c-8.2,4.7-14.9,16.3-14.9,25.9,0,6.1,2.8,9.8,7.3,9.8a13.7,13.7,0,0,0,6.3-1.9C191.9,163.9,198.6,152.2,198.6,142.6Zm-3.9,10.8c-.2.3-.5.6-.8.6l-2.5-.2a.5.5,0,0,1-.5-.3.8.8,0,0,1,0-.8l.3-.6a1,1,0,0,1,.9-.6l2.5.2a.5.5,0,0,1,.5.3,1.1,1.1,0,0,1,0,.8Zm1.5-9.2a.7.7,0,0,1,.4.7v.5a1,1,0,0,1-.6.9l-2.8,1.6h-.7a.7.7,0,0,1-.3-.6v-.5a1,1,0,0,1,.6-.9l2.8-1.6C195.7,144.1,196,144.1,196.2,144.2ZM188,140l1.3-3.6a.9.9,0,0,1,.8-.6h.4a.5.5,0,0,1,.5.3.8.8,0,0,1,0,.8l-1.4,3.6a.9.9,0,0,1-.8.6h-.4a.5.5,0,0,1-.5-.3A2.5,2.5,0,0,1,188,140Zm-4.5-1.7a1,1,0,0,1,.6-.9l.4-.2a.7.7,0,0,1,.6-.1.7.7,0,0,1,.4.7V141a1.1,1.1,0,0,1-.5.9l-.4.3h-.3c-.7,0-.8-.4-.8-.7Zm-5.7,5.5c-.3-.3-.1-.7.1-1a.1.1,0,0,1,.1-.1l.4-.5h0l.6-.3.5.2,1.4,2.1c.3.3.1.7-.1,1a.1.1,0,0,1-.1.1l-.4.5a.8.8,0,0,1-.7.3l-.5-.2Zm-4.4,6.7.3-.6a1,1,0,0,1,.9-.6l2.5.2h0a.5.5,0,0,1,.5.3.8.8,0,0,1,0,.8l-.3.6c-.2.3-.5.6-.8.6l-2.5-.2a.5.5,0,0,1-.5-.3C173.3,151,173.2,150.7,173.4,150.5Zm-.9,8.7c-.7,0-.8-.4-.8-.7V158a1,1,0,0,1,.6-.9l2.8-1.6a.7.7,0,0,1,.6-.1.7.7,0,0,1,.4.7v.5a1.1,1.1,0,0,1-.5.9l-2.8,1.6Zm4.6,2.5-2.5,3a1.1,1.1,0,0,1-.6.3l-.5-.2-.3-.4c-.3-.3-.1-.7,0-1h.1l2.4-3a1,1,0,0,1,.5-.4c.2,0,.5,0,.6.2l.3.4c.3.3.1.7,0,1S177.2,161.7,177.1,161.7Zm3.3,1.5-1.4,3.6a.9.9,0,0,1-.8.6h-.4a.5.5,0,0,1-.5-.3.8.8,0,0,1,0-.8l1.4-3.6a.9.9,0,0,1,.8-.6h.4a.5.5,0,0,1,.5.3A1.1,1.1,0,0,1,180.4,163.2Zm4.5,1.7a1.1,1.1,0,0,1-.5.9l-.4.3h-.3c-.7,0-.8-.4-.8-.7v-3.2a1,1,0,0,1,.6-.9l.4-.3h0a.6.6,0,0,1,.7,0,.9.9,0,0,1,.3.6Zm1.4-10.2a1.8,1.8,0,0,1-1.3-1.1l-.7.4-.5.7-1.2,2.7-.3.3h-.4a.8.8,0,0,0-.9,0h-.5c-.2-.1-.2-.3-.2-.5a1.9,1.9,0,0,0-.3-1.2.5.5,0,0,1,0-.7l1.9-2,.5-.9a2.5,2.5,0,0,1,.1-.8l-1.3-.6a1.8,1.8,0,0,1-1.1.4,1.5,1.5,0,0,1-1.2-.9,12.7,12.7,0,0,1-1-2.4v-.4l.3-.2,2.5-.3a1.9,1.9,0,0,1,1.4.5,1.4,1.4,0,0,1,.2,1.2l1.2.8a1.8,1.8,0,0,1,.7-.5h0l.5-.2c.9-1.3,2.3-3.2,4.2-6.1,5-7.5,5.4-7.4,5.8-7.3h.3c.2.2.3.4-.9,2.5a.8.8,0,0,1,.8.1l.3.4c.3.3.1.7,0,1a.1.1,0,0,1-.1.1l-2.5,3-.6.3-.5-.2-.2-.2-.8,1.2c-1.9,3-3.2,5-4,6.4h0a.9.9,0,0,1-.1.5,1.8,1.8,0,0,1,1.6.6,2.2,2.2,0,0,1-1.7,3C186.4,154.8,186.3,154.7,186.3,154.7Zm1.3,3.2h0l.4-.5h.3a.8.8,0,0,1,.9,0l1.4,2.1c.3.3.1.7-.1,1h-.1l-.4.5-.6.3h0a.6.6,0,0,1-.5-.2l-1.4-2.1A1.4,1.4,0,0,1,187.6,157.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M184.6,170.1c8.7-5,15.7-17.3,15.7-27.3,0-7-3.5-11.5-9-11.5a14,14,0,0,0-7.1,2.2c-8.7,5-15.7,17.3-15.7,27.3,0,7,3.5,11.5,9,11.5A14.3,14.3,0,0,0,184.6,170.1Zm6.8-38.2c5,0,8.3,4.2,8.3,10.7,0,9.9-6.9,21.9-15.4,26.8h0a14,14,0,0,1-6.8,2.1c-5.1,0-8.3-4.1-8.3-10.8,0-9.9,6.9-21.8,15.4-26.7A13.7,13.7,0,0,1,191.4,131.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M185.1,170.9a24.2,24.2,0,0,0,4.5-3.4l11.1-6.4V148.2a26.4,26.4,0,0,0,.6-5.5,18.8,18.8,0,0,0-.6-4.9V123.1L187,131a16.6,16.6,0,0,0-3.3,1.6,20.2,20.2,0,0,0-3,2.1L168,142v13.7a29.4,29.4,0,0,0-.5,5.1,21.4,21.4,0,0,0,.5,4.5V180l12.3-7.1A13.3,13.3,0,0,0,185.1,170.9Zm-16.6-10.1c0-10.1,7.1-22.3,15.7-27.3a14.6,14.6,0,0,1,7.1-2.2c5.5,0,9,4.5,9,11.5,0,10.1-7.1,22.3-15.7,27.3a14.6,14.6,0,0,1-7.1,2.2C172,172.3,168.5,167.8,168.5,160.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M169.1,160.7c0,6.7,3.2,10.8,8.3,10.8a14,14,0,0,0,6.8-2.1h0c8.5-4.9,15.4-16.9,15.4-26.8,0-6.5-3.2-10.7-8.3-10.7a14,14,0,0,0-6.8,2.1C176,138.9,169.1,150.9,169.1,160.7Zm14.6,7.9a13.2,13.2,0,0,1-6.3,1.9c-4.5,0-7.3-3.8-7.3-9.8,0-9.5,6.7-21.1,14.9-25.9a13.2,13.2,0,0,1,6.3-1.9c4.5,0,7.3,3.7,7.3,9.7C198.6,152.2,191.9,163.9,183.7,168.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M182.7,153.9a.3.3,0,0,1-.1-.2v.2h-.1l-1.6,1.7.3.8h.8l1-2.3a.1.1,0,0,1,.1-.1V154Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M185.8,149.1h.1a.3.3,0,0,1,.1.2l3.7-5.8.8-1.3a8.3,8.3,0,0,1-.8,1.2h0Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M182.8,150.6l-1.4-.9a.5.5,0,0,1-.2-.6.9.9,0,0,0,0-.7h-.5l-1.8.2a11.8,11.8,0,0,0,.8,1.6c.1.1.2.4.4.4s.5-.2.5-.3l.4-.2h.2l1.5.7A.3.3,0,0,1,182.8,150.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M187.3,152.3a2.2,2.2,0,0,0-1.2-.2,4.3,4.3,0,0,1-.4.7c.4.8.7.9.7.9a1,1,0,0,0,.7-.6A1.7,1.7,0,0,0,187.3,152.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M188,153.6a1.9,1.9,0,0,0,.1-1.9,1.8,1.8,0,0,0-1.6-.6c0-.2.1-.3.1-.5h0c.8-1.4,2.1-3.4,4-6.4l.8-1.2.2.2a.6.6,0,0,0,.5.2.9.9,0,0,0,.6-.3l2.5-3h.1c.1-.2.3-.7,0-1l-.3-.4a.8.8,0,0,0-.8-.1c1.2-2.1,1.1-2.3.9-2.5h-.3c-.4-.1-.8-.2-5.8,7.3l-4.2,6.1-.5.2h0l-.7.5-1.2-.8a1.4,1.4,0,0,0-.2-1.2,1.3,1.3,0,0,0-1.4-.5l-2.5.3c-.1,0-.3.1-.3.2a.3.3,0,0,0,0,.4,16.7,16.7,0,0,0,1,2.4c.4.7.8.9,1.2.9a1.2,1.2,0,0,0,1.1-.4l1.3.6a2.2,2.2,0,0,0-.1.8l-.5.9-1.9,2a.5.5,0,0,0,0,.7,1.5,1.5,0,0,1,.3,1.2.8.8,0,0,0,.2.5h.5c.5-.3.9-.1.9,0h.4a.3.3,0,0,0,.3-.3l1.2-2.7.5-.7.7-.4a2.3,2.3,0,0,0,1.3,1.1h.1A2.8,2.8,0,0,0,188,153.6Zm-1.6.2c-.1,0-.3-.1-.7-.9a2.5,2.5,0,0,0,.4-.7c.7-.1,1.1,0,1.2.2s.1.4-.1.8S186.6,153.8,186.4,153.8Zm-3.6.5-1,2.3H181l-.3-.8,1.6-1.7h.1v-.2c0,.1.1.1.1.2h.2v.3ZM181,150l-.4.2a.9.9,0,0,1-.5.3c-.2,0-.3-.3-.4-.4l-.8-1.6,1.8-.2h.5a.8.8,0,0,1,0,.7.5.5,0,0,0,.2.6l1.4.9c0,.1-.1.1-.1.2l-1.5-.7Zm10.9-7.9Zm-2.2,1.4h0l.8-1.2-.8,1.2-3.7,5.9c0-.1-.1-.1-.1-.2h-.1C186.7,147.8,187.9,146,189.7,143.5Zm-6.5,9a3.2,3.2,0,0,1,1.4-2.4c.3-.1.6-.2.7-.1s.2.4.2.6a3.2,3.2,0,0,1-1.4,2.4.6.6,0,0,1-.7.1A.8.8,0,0,1,183.2,152.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M183.4,153.1c.1.1.4,0,.7-.1a3.2,3.2,0,0,0,1.4-2.4.7.7,0,0,0-.2-.6c-.1-.1-.4-.1-.7.1a3.2,3.2,0,0,0-1.4,2.4A.8.8,0,0,0,183.4,153.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M184.2,142.2h.3l.4-.3a1.1,1.1,0,0,0,.5-.9v-3.2a.8.8,0,0,0-.4-.7c-.2-.1-.5-.1-.6.1l-.4.2a1.1,1.1,0,0,0-.6.9v3.2C183.5,141.8,183.6,142.2,184.2,142.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M178.6,143.2Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M179.9,144.7h0l-1-1.6v.2h0l1,1.5Z" transform="translate(-0.5 -0.8)" />
      <path
        d="M179.7,146.1l.7-.3.4-.5a.1.1,0,0,1,.1-.1c.1-.2.3-.7.1-1l-1.4-2.1-.5-.2a.6.6,0,0,0-.6.3h0l-.4.5a.1.1,0,0,1-.1.1c-.1.2-.3.7-.1,1l1.4,2.1Zm-1.1-2.9Zm.1.2h0l.2-.2,1,1.5h0v.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="175.8 149.9 175.9 149.6 174 149.5 173.9 149.8 175.8 149.9" />
      <path
        d="M173.9,151.5l2.5.2a.8.8,0,0,0,.8-.6l.3-.6a1.1,1.1,0,0,0,0-.8.5.5,0,0,0-.5-.3h0l-2.5-.2a1.1,1.1,0,0,0-.9.6l-.3.6a1.1,1.1,0,0,0,0,.8A.9.9,0,0,0,173.9,151.5Zm2.5-1.1v.3h-1.9v-.3Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M176.2,156.6v-.5a.8.8,0,0,0-.4-.7.5.5,0,0,0-.6.1l-2.8,1.6a1.1,1.1,0,0,0-.6.9v.5c0,.3.1.7.8.7h.3l2.8-1.6A1.1,1.1,0,0,0,176.2,156.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M174,163.8Z" transform="translate(-0.5 -0.8)" />
      <path
        d="M177.2,160.6l-.3-.4a.7.7,0,0,0-.6-.2.7.7,0,0,0-.5.4l-2.4,3h-.1c-.1.2-.3.7,0,1l.3.4a.6.6,0,0,0,.5.2l.6-.3,2.5-3a.1.1,0,0,1,.1-.1C177.3,161.3,177.5,160.9,177.2,160.6Zm-3.2,3.2Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M179.9,162.1h-.4a.8.8,0,0,0-.8.6l-1.4,3.6a1.1,1.1,0,0,0,0,.8.5.5,0,0,0,.5.3h.4a.8.8,0,0,0,.8-.6l1.4-3.6a1.1,1.1,0,0,0,0-.8A.9.9,0,0,0,179.9,162.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M184.6,161.1a.6.6,0,0,0-.7,0h0l-.4.3a1.1,1.1,0,0,0-.6.9v3.2c0,.3.1.7.8.7h.3l.4-.3a1.1,1.1,0,0,0,.5-.9v-3.2A.9.9,0,0,0,184.6,161.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M189.7,159.8h0l-1-1.6v.2h0l1,1.5Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M188.4,158.3Z" transform="translate(-0.5 -0.8)" />
      <path
        d="M189.5,161.2h0a.9.9,0,0,0,.6-.3l.4-.5h.1c.1-.2.3-.7.1-1l-1.4-2.1q-.3-.3-.9,0h-.3l-.4.5h-.1c-.1.2-.3.7-.1,1l1.4,2.1Zm-1.1-2.9Zm.1.1v-.2l1,1.5h0v.2l-1-1.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="191.5 151.8 191.4 152.1 193.2 152.2 193.4 151.9 191.5 151.8" />
      <path
        d="M194.9,152a.5.5,0,0,0-.5-.3l-2.5-.2a1.1,1.1,0,0,0-.9.6l-.3.6a1.1,1.1,0,0,0,0,.8.5.5,0,0,0,.5.3l2.5.2a.8.8,0,0,0,.8-.6l.3-.6A.8.8,0,0,0,194.9,152Zm-1.2,1h-1.9v-.3h1.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        d="M192.2,146.8v.5a.7.7,0,0,0,.3.6h.7l2.8-1.6a1.1,1.1,0,0,0,.6-.9v-.5a.8.8,0,0,0-.4-.7.5.5,0,0,0-.6.1l-2.8,1.6A.9.9,0,0,0,192.2,146.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M191.9,142.1Z" transform="translate(-0.5 -0.8)" />
      <path
        d="M188.5,141.1h.4a.8.8,0,0,0,.8-.6l1.4-3.6a1.1,1.1,0,0,0,0-.8.5.5,0,0,0-.5-.3h-.4a.8.8,0,0,0-.8.6L188,140a1.1,1.1,0,0,0,0,.8A.5.5,0,0,0,188.5,141.1Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="135 115.3 137.8 116.9 137.8 105.8 135 104.1 135 115.3" />
      <polygon class="cls-1" points="122.2 107.9 125 109.5 125 98.4 122.2 96.8 122.2 107.9" />
      <polygon class="cls-1" points="128.6 111.6 131.3 113.2 131.3 102 128.6 100.5 128.6 111.6" />
      <polygon class="cls-1" points="147.9 122.7 150.7 124.4 150.7 113.2 147.9 111.6 147.9 122.7" />
      <polygon class="cls-1" points="141.5 119 144.2 120.6 144.2 109.5 141.5 107.9 141.5 119" />
      <path
        class="cls-1"
        d="M120.1,96.1v11.5a1.1,1.1,0,0,0,.3.7l1.3.8V97Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M126.5,111.3a1.1,1.1,0,0,0,.3.7l1.3.8V100.7l-1.6-1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M145.7,122.4a1.1,1.1,0,0,0,.3.7l1.3.8V111.8l-1.6-1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M132.8,115a1.1,1.1,0,0,0,.3.7l1.3.8v-12l-1.6-1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M139.3,118.7a1.1,1.1,0,0,0,.3.7l1.3.8v-12l-1.7-1v11.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M152.2,126.1a1.1,1.1,0,0,0,.3.7l1.3.8v-12l-1.6-1Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="198.3 105.7 198.9 105.4 198.9 94.4 198.3 94.7 198.3 105.7" />
      <polygon class="cls-1" points="191.8 109.5 194.7 107.9 194.7 96.8 191.8 98.4 191.8 109.5" />
      <polygon class="cls-1" points="185.4 113.2 188.2 111.6 188.2 100.5 185.4 102.1 185.4 113.2" />
      <polygon class="cls-1" points="179 116.9 181.8 115.3 181.8 104.2 179 105.8 179 116.9" />
      <polygon class="cls-1" points="166.2 124.4 168.9 122.8 168.9 111.6 166.2 113.2 166.2 124.4" />
      <polygon class="cls-1" points="172.5 120.7 175.4 119 175.4 107.9 172.5 109.5 172.5 120.7" />
      <path
        class="cls-1"
        d="M196.2,109l1.3-.8a1.1,1.1,0,0,0,.3-.7V96.1l-1.6,1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M189.7,112.8l1.3-.8a1.1,1.1,0,0,0,.3-.7V99.8l-1.7,1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M170.4,123.8l1.3-.8a1.1,1.1,0,0,0,.3-.7V110.8l-1.6,1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M183.3,116.4l1.3-.8a1.1,1.1,0,0,0,.3-.7V103.4l-1.7,1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M176.9,120.2l1.3-.8a1.1,1.1,0,0,0,.3-.7V107.2l-1.7,1Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M164,127.6l1.3-.8a1.1,1.1,0,0,0,.3-.7V114.6l-1.7,1v12Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon
        class="cls-1"
        points="158.9 128.5 158.9 129.4 158.9 130.4 159.9 129.8 159.7 116.9 158.9 117.4 158.9 128.5"
      />
      <polygon
        class="cls-1"
        points="156.9 129.8 157.9 130.4 157.9 129.4 157.9 128.5 157.9 117.4 157.2 116.9 156.9 129.8"
      />
      <polygon
        class="cls-1"
        points="160.7 116.4 160.9 129.4 162.5 129 162.5 126.9 162.5 115.3 160.7 116.4"
      />
      <polygon
        class="cls-1"
        points="154.4 115.3 154.4 126.9 154.4 129 155.9 129.4 156.2 116.4 154.4 115.3"
      />
      <polygon class="cls-1" points="117 106.3 117.7 105.9 117.7 94.2 117 93.8 117 106.3" />
      <polygon class="cls-1" points="116 93.2 115.1 92.7 114.8 105.7 116 106.3 116 93.2" />
      <polygon class="cls-1" points="112.1 104.9 113.8 105.3 114.1 92.1 112.1 90.9 112.1 104.9" />
      <polygon class="cls-1" points="199.9 105.5 200.7 105.9 200.7 93.3 199.9 93.8 199.9 105.5" />
      <polygon class="cls-1" points="202.6 92.2 201.7 92.7 201.7 105.9 202.9 105.2 202.6 92.2" />
      <polygon class="cls-1" points="205.6 90.5 203.6 91.6 203.9 104.8 205.6 104.4 205.6 90.5" />
      <path
        class="cls-1"
        d="M158.9,117.3l48-27.7V87.8l-47.8,27.6h-.4L110.9,87.8v1.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M153.8,43.8l-.9-.5v9a.4.4,0,0,1-.1.3l1,.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M158.4,46.5l-1.6-.9v9.3l1.6.9Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M149.8,41.5l-1-.6v9a.4.4,0,0,1-.1.3l1.1.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M145.6,39.1l-.9-.5v9.3l1,.6V39.1Z" transform="translate(-0.5 -0.8)" />
      <polygon class="cls-1" points="139.8 44.6 141.1 45.4 141.1 36 139.8 35.3 139.8 44.6" />
      <path
        class="cls-1"
        d="M143.7,47.4V38.1l-1.1-.6v9a.8.8,0,0,0,.2.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M155.9,54.4V45.1l-1.1-.6v9a.8.8,0,0,0,.2.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M147.7,49.6V40.3l-1.1-.6v8.9a.8.8,0,0,0,.2.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M151.8,52V42.7l-1.1-.6V51a.8.8,0,0,0,.2.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <polygon class="cls-1" points="175.4 36.2 175.4 45.6 177 44.6 177 35.3 175.4 36.2" />
      <path class="cls-1" d="M169,50.2V41l-.8.5v9.4l.8-.5Z" transform="translate(-0.5 -0.8)" />
      <path class="cls-1" d="M164.3,43.7v9.4l.9-.5V43.2Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M161.3,54.6V45.5l-1.8,1.1V56l1.9-1.1C161.3,54.7,161.3,54.7,161.3,54.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M172.9,38.8l-.8.5v9.4l.8-.5V38.8Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M174.9,37.6l-1,.6v9.5l.8-.5h.1a1,1,0,0,0,.1-.3V37.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M163.2,53.8a1,1,0,0,0,.1-.3V44.3l-1,.6v9.4l.9-.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M171,39.8l-1,.6v9.5l.8-.5h.1a1,1,0,0,0,.1-.3V39.8Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M167.1,51.6a1,1,0,0,0,.1-.3V42l-1,.6v9.5l.9-.5Z"
        transform="translate(-0.5 -0.8)"
      />
      <path class="cls-1" d="M159,45.6Z" transform="translate(-0.5 -0.8)" />
      <path
        class="cls-1"
        d="M111.3,86.9l47.2,27.3V57L140,46.3C138,50.1,124.7,74.8,111.3,86.9Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M159.4,3.6V44.2l17.8-10.3C171.4,28.2,162.4,9.8,159.4,3.6Z"
        transform="translate(-0.5 -0.8)"
      />
      <path
        class="cls-1"
        d="M140.7,33.9l17.8,10.3V3.6C155.5,9.8,146.4,28.2,140.7,33.9Z"
        transform="translate(-0.5 -0.8)"
      />
    </g>
    <g id="FrontScreen">
      <g id="Table">
        <path
          class="cls-3"
          d="M198.3,240.3l1.2.7,2.8-1.7.3-.2a2.5,2.5,0,0,1,2.3.3l43.2,24.9a6.5,6.5,0,0,1,1.8,1.6l.8-.5a7.5,7.5,0,0,0-2.7-3.5L204.7,237a2.4,2.4,0,0,0-1.2-.5l-.6.2h-.2l-5.3,3.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M248.1,264.3l-43.2-24.9a2.8,2.8,0,0,0-2.3-.3l-.3.2-2.8,1.7,42,24.2a8.1,8.1,0,0,1,3,3.7l5.4-3.1A9,9,0,0,0,248.1,264.3Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M248.4,261.2l-43.2-24.9a3.1,3.1,0,0,0-2.6-.3l-.3.2L196,240h0l-.4.2a3.6,3.6,0,0,0-1.5,3.3v30.3c0,2.7,1.6,6,3.7,7.2L241,305.9a3.3,3.3,0,0,0,1.6.5h.8l7-4.2c1-.5,1.6-1.6,1.6-3.3V268.5C252.1,265.7,250.5,262.4,248.4,261.2Zm-6.9,44.1-43.2-24.9a8.4,8.4,0,0,1-3.4-6.5V243.6a3,3,0,0,1,1-2.6l.7-.2a1.9,1.9,0,0,1,1.2.4L241,266.1a8.4,8.4,0,0,1,3.4,6.5v30.3a3,3,0,0,1-1,2.6A2.2,2.2,0,0,1,241.5,305.3Zm-38.6-68.5.6-.2a2.4,2.4,0,0,1,1.2.5L247.9,262a7.5,7.5,0,0,1,2.7,3.5l-.8.5-5.4,3.1a7.5,7.5,0,0,0-3-3.7l-42-24.2-1.2-.7-.9-.4,5.3-3.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M202,273.4l.7.4v-3.1c0-.5.3-.7.6-.5l2.9,1.7v-1a1.1,1.1,0,0,0-.5-.9l-4.3-2.5v5A2,2,0,0,0,202,273.4Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M218.2,282.8h0V263.9c0-1,.6-1.5,1.4-1l2.4,1.4v-.2a3,3,0,0,0-1.1-2.2l-3-1.7a.4.4,0,0,0-.5-.1.9.9,0,0,0-.3.7v19.8A3.8,3.8,0,0,0,218.2,282.8Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M233.7,291.8l.6.4v-4.9c0-.5.4-.8.7-.5l2.8,1.6v-1a1.4,1.4,0,0,0-.5-1.1l-4.1-2.4a.4.4,0,0,0-.1.3v6.6A1.5,1.5,0,0,0,233.7,291.8Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M226.2,287.5l.3.2V272c0-.8.5-1.2,1.1-.8l2.6,1.5v-.5a2.4,2.4,0,0,0-.9-1.7l-3.5-2h-.2a.5.5,0,0,0-.3.5v16.9A2.2,2.2,0,0,0,226.2,287.5Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M209.9,278l.5.3V268c0-.7.5-1,.9-.7l2.6,1.5v-.6a2.6,2.6,0,0,0-.7-1.5l-3.7-2.2h-.1c-.1,0-.2.2-.2.4v11.6A2.6,2.6,0,0,0,209.9,278Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M243.5,305.5a3,3,0,0,0,1-2.6V272.6a8.4,8.4,0,0,0-3.4-6.5l-43.2-24.9a1.9,1.9,0,0,0-1.2-.4l-.7.2a3,3,0,0,0-1,2.6v30.3a8.4,8.4,0,0,0,3.4,6.5l43.2,24.9A2.2,2.2,0,0,0,243.5,305.5Zm-11.3-21.4a1.1,1.1,0,0,1,.5-1,.8.8,0,0,1,.9,0l4.1,2.4a2.5,2.5,0,0,1,1,1.8v1.5l.5.3a1.7,1.7,0,0,1,.7,1.5v6.6c.1.5-.3.8-.7.5l-4.1-2.4a1.7,1.7,0,0,1-.7-1.5v-.6l-1.1-.6a2.5,2.5,0,0,1-1-1.8v-6.7Zm-7.7-15.3a1.9,1.9,0,0,1,.5-1.3.9.9,0,0,1,1.1.1l3.5,2a3.3,3.3,0,0,1,1.3,2.5v.9h.2a2.7,2.7,0,0,1,1.1,2.1v16.9c0,.7-.5,1.1-1.1.8l-3.5-2a2.7,2.7,0,0,1-1.1-2.1v-.3l-.7-.4a3.3,3.3,0,0,1-1.3-2.5Zm-8.3-8a2.3,2.3,0,0,1,.6-1.5,1.2,1.2,0,0,1,1.3.1l3,1.7a3.6,3.6,0,0,1,1.6,2.9v.6a3.3,3.3,0,0,1,1.3,2.5V287c-.1,1-.6,1.5-1.4,1l-3-1.7a3.3,3.3,0,0,1-1.4-2.4l-.5-.3a3.6,3.6,0,0,1-1.6-2.9V260.8Zm-7.8,4.1a1.3,1.3,0,0,1,.5-1.1.8.8,0,0,1,1,.1l3.8,2.1a3,3,0,0,1,1.2,2.2v1.2h.2a2.3,2.3,0,0,1,.9,1.8v11.6c0,.7-.5,1.1-.9.7l-3.7-2.2a2.3,2.3,0,0,1-.9-1.8v-.4l-.9-.5a3,3,0,0,1-1.2-2.2V264.9Zm-7.8,2.8a.9.9,0,0,1,.5-.9c.3-.2.5-.1.8,0l4.3,2.5a2,2,0,0,1,.9,1.6v1.4l.5.3a1.5,1.5,0,0,1,.6,1.3v4.8c0,.5-.3.7-.6.5l-4.3-2.5a1.5,1.5,0,0,1-.6-1.3v-.7l-1.2-.7a2,2,0,0,1-.9-1.6Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M218.2,263.9v18.9l3,1.7a.4.4,0,0,0,.5.1.9.9,0,0,0,.3-.7V264.3l-2.4-1.4C218.9,262.4,218.2,262.9,218.2,263.9Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M222.1,285.4l-.5.2-.7-.2-2.5-1.5a3.5,3.5,0,0,0,1.4,2.4l3,1.7c.7.5,1.3,0,1.4-1V267.2a3.3,3.3,0,0,0-1.3-2.5v19.2A3.1,3.1,0,0,1,222.1,285.4Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M217.8,283.6l.5.3,2.5,1.5.7.2.5-.2a1.8,1.8,0,0,0,.6-1.5V264.1a3.2,3.2,0,0,0-1.6-2.9l-3-1.7a1.2,1.2,0,0,0-1.3-.1,1.8,1.8,0,0,0-.6,1.5v19.9A4,4,0,0,0,217.8,283.6Zm-.6-22.8a.8.8,0,0,1,.3-.7.4.4,0,0,1,.5.1l3,1.7a3.3,3.3,0,0,1,1.1,2.2v19.8a.8.8,0,0,1-.3.7.4.4,0,0,1-.5-.1l-3-1.7h0a3.3,3.3,0,0,1-1.1-2.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M226.5,271.9v15.7l3.2,1.9h.3a.6.6,0,0,0,.2-.5V272.7l-2.6-1.5C226.9,270.7,226.5,271.1,226.5,271.9Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M230.3,290.3h-.5l-.6-.2-2.7-1.6v.3a2.7,2.7,0,0,0,1.1,2.1l3.5,2c.5.3,1.1-.1,1.1-.8V275.2a2.7,2.7,0,0,0-1.1-2.1h-.2v16A1.5,1.5,0,0,1,230.3,290.3Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M225.7,288.1l.7.4,2.7,1.6.6.2h.5a1.4,1.4,0,0,0,.5-1.3V272.1a3,3,0,0,0-1.3-2.5l-3.5-2a.9.9,0,0,0-1.1-.1,1.4,1.4,0,0,0-.5,1.3v16.8A4.1,4.1,0,0,0,225.7,288.1Zm-.4-19.3c0-.3.1-.5.3-.5h.2l3.5,2a2.2,2.2,0,0,1,.9,1.7V289c0,.4-.1.5-.2.5h-.3l-3.2-1.9-.3-.2a2.2,2.2,0,0,1-.9-1.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M234.3,287.2v4.9l3.5,2h.1v-5.9l-2.8-1.6C234.7,286.4,234.3,286.6,234.3,287.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M238.3,294.9c0,.1-.2.2-.4.2l-.5-.2-3-1.7v.6a2.1,2.1,0,0,0,.7,1.5l4.1,2.4c.5.3.8,0,.7-.5v-6.6a2.1,2.1,0,0,0-.7-1.5l-.5-.3v5.1A1.5,1.5,0,0,1,238.3,294.9Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M233.2,292.5l1.1.6,3,1.7.5.2c.2,0,.4-.1.4-.2a1.1,1.1,0,0,0,.5-1v-6.6a2.4,2.4,0,0,0-1-1.8l-4.1-2.4a.8.8,0,0,0-.9,0,1.1,1.1,0,0,0-.5,1v6.6A2.6,2.6,0,0,0,233.2,292.5Zm-.1-8.4a.4.4,0,0,1,.1-.3l4.1,2.4c.3.1.5.6.5,1.1v6.9h-.1l-3.5-2-.6-.4a1.3,1.3,0,0,1-.5-1.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M210.5,268v10.3l3.2,1.9h.2c.1,0,.1-.2.1-.4V268.8l-2.6-1.5C210.9,267,210.5,267.3,210.5,268Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M214.4,280.9a.6.6,0,0,1-.5.2l-.5-.2-2.8-1.7v.4a2.1,2.1,0,0,0,.9,1.8l3.7,2.2c.5.4.9,0,.9-.7V271.3a2.1,2.1,0,0,0-.9-1.8H215v10.4A1.1,1.1,0,0,1,214.4,280.9Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M209.6,278.7l.9.5,2.8,1.7.5.2c.2,0,.4,0,.5-.2s.5-.5.5-1.1V268.2a2.7,2.7,0,0,0-1.2-2.2l-3.8-2.1a.8.8,0,0,0-1-.1c-.4.2-.5.5-.5,1.1v11.6A3.2,3.2,0,0,0,209.6,278.7Zm-.4-13.8c0-.2.1-.4.2-.4h.1l3.7,2.2a2,2,0,0,1,.7,1.5v11.7c0,.2,0,.4-.1.4h-.2l-3.2-1.9-.5-.3a2,2,0,0,1-.7-1.5Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M206.6,276.7h-.9l-3.1-1.8v.7a1.8,1.8,0,0,0,.6,1.3l4.3,2.5c.4.2.6,0,.6-.5v-4.8a1.8,1.8,0,0,0-.6-1.3l-.5-.3v3.4A.7.7,0,0,1,206.6,276.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M202.7,270.7v3.1l3.6,2v-4l-2.9-1.7A.6.6,0,0,0,202.7,270.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M201.5,274.2l1.2.7,3.1,1.8h.9a1.1,1.1,0,0,0,.5-.9V271a2.2,2.2,0,0,0-.9-1.6l-4.3-2.5c-.3-.1-.5-.2-.8,0a1.1,1.1,0,0,0-.5.9v4.8A1.9,1.9,0,0,0,201.5,274.2Zm0-6.6v-.2l4.3,2.5a1.1,1.1,0,0,1,.5.9v5l-3.6-2-.7-.4a1.1,1.1,0,0,1-.5-.9Z"
          transform="translate(-0.5 -0.8)"
        />
      </g>
      <g id="Screen">
        <path
          class="cls-3"
          d="M215.3,404.2a2.3,2.3,0,0,0,1-1.6l-1.1.6-3.4-2v5.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M95,233.7l115.4,65.8a9.7,9.7,0,0,1,3.9,4.7l.2.5-3.5,2.1a13,13,0,0,1,.8,3.4l3.4-2v2.6l-3.4,2.1v52.9l4.5,2.6V307.9c0-3.6-2.2-7.7-4.8-9.2l-115.4-66a2.9,2.9,0,0,0-3.1-.1l-.8.5A3.8,3.8,0,0,1,95,233.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M214.3,304.1a11.5,11.5,0,0,0-3.9-4.7L95,233.7a3.3,3.3,0,0,0-2.8-.5l-2.5,1.5,1.4.6L206.5,301a11.7,11.7,0,0,1,4.5,5.8l3.5-2.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M215.2,308.1l-3.4,2c0,.4.1.7.1,1.1v1.5l3.4-2.1v-2.5Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M216.3,402.6a2.1,2.1,0,0,1-1,1.6l-3.5,2.1v-5.1l-1.1-.6v5.8c0,1.5-.5,2.6-1.4,3a3.3,3.3,0,0,1-3.4-.4L91.4,343.7a11.4,11.4,0,0,1-5.3-9V324.1l104.6,59.7-2.3,1.3,6.3,3.7L212.3,399l3.7-2.1c3.7-2,3.4-10,3.4-10.5V370l-1.9-1.1V307.7c0-3.9-2.4-8.5-5.4-10.2L96.7,231.7a3.7,3.7,0,0,0-4.3,0l-5.2,3.1h-.1l-.3.2-.4.3h0a5.2,5.2,0,0,0-1.3,4.1v94.8h0v.5a11.4,11.4,0,0,0,1.5,5.2,11.3,11.3,0,0,0,3.9,4.4h.2l.3.2,114.6,65.3a5.6,5.6,0,0,0,2.7.8,3.5,3.5,0,0,0,1.4-.3h.4l.3-.2,5.1-3.1c1.4-.7,2.2-2.4,2.2-4.7v-.7ZM96.1,232.7l115.4,65.8c2.6,1.6,4.8,5.7,4.8,9.2v60.5l-4.5-2.6V311.2a4.1,4.1,0,0,0-.1-1.1,14,14,0,0,0-.8-3.4,11.7,11.7,0,0,0-4.5-5.8L91.1,235.2l-1.4-.6,2.5-1.5.8-.5A2.9,2.9,0,0,1,96.1,232.7ZM218.2,373.2v13.2c.1,2.1-.2,7.9-2.7,9.4l-3.1,1.7L196,388l-5.1-3,2.4-1.4c3.7-2.1,3.4-10.1,3.4-10.5v-15l21.6,12.4v2.7Zm-23,4.8L93.4,320a3.9,3.9,0,0,1-1.6-2.9V244.6a1.1,1.1,0,0,1,.4-1h.2l.5.2,110.6,63.1a3.9,3.9,0,0,1,1.6,2.9v52l-9.6-5.6v17.1A29.3,29.3,0,0,1,195.2,378Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M190.7,383.8,86.1,324.1v10.6a11.3,11.3,0,0,0,5.3,9L206,409.1a3.6,3.6,0,0,0,3.4.4,3.3,3.3,0,0,0,1.4-3v-5.8l-18.3-10.6,2.2-1.3-6.3-3.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M205.1,361.7v-52a3.5,3.5,0,0,0-1.6-2.9L92.9,243.7l-.5-.2h-.2a1.1,1.1,0,0,0-.4,1V317a3.5,3.5,0,0,0,1.6,2.9l101.7,58a22.1,22.1,0,0,0,.3-4.8V356Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M196.6,358.3v15c0,.4.3,8.4-3.4,10.5l-2.4,1.4,5.1,3c3.4-2,3-9.9,3-9.9V362.2l19.2,11.1v-2.5Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M221.7,391.3V375.2l-2.3-1.3v12.5c0,.5.3,8.5-3.4,10.5l-3.7,2.1-17.6-10.2-2.2,1.3,18.3,10.6,1.1.6,3.4,2,1.1-.6,1.2-.7,1.1-.6C222,399.4,221.7,391.3,221.7,391.3Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M208.3,380l-.2.7,4.2,1.4a2.2,2.2,0,0,0-.1-.8Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M199,362.1v16.1s.4,7.9-3,9.9l16.4,9.5,3.1-1.7c2.6-1.5,2.8-7.3,2.7-9.4V373.3Zm14.3,19c.1.5.1,1,.2,1.4l.7.2a8.8,8.8,0,0,1,.2,1.6c0,4-2.8,5.7-6.3,3.7a8.3,8.3,0,0,1-1.6-1.2h-.2a14.4,14.4,0,0,1-6.6-11.4,5.1,5.1,0,0,1,2.1-4.6c1.4-.8,3.1-.6,5,.5a8.3,8.3,0,0,1,1.6,1.2l.3.2-.3,1.1.6.4.8-3.5.6.5a15,15,0,0,1,4.7,7.9,9.2,9.2,0,0,1,.8,2.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M210.5,377.8l1-4h.1l-1-1.2-1.2,4.8Z"
          transform="translate(-0.5 -0.8)"
        />
        <polygon class="cls-2" points="208 378.3 209.6 378.7 209.7 378.1 208.2 377.6 208 378.3" />
        <path
          class="cls-2"
          d="M207.4,373.2V373a4.2,4.2,0,0,0-1.2-.8,5.6,5.6,0,0,0-2.6-.8,2.3,2.3,0,0,0-1.4.4c-1,.5-1.6,1.8-1.6,3.7a12.3,12.3,0,0,0,2,6.2,12.1,12.1,0,0,1-1-4.4C201.8,373.4,204.3,371.8,207.4,373.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M211.4,387.2a5.3,5.3,0,0,1-2,.5,5.8,5.8,0,0,1-2.9-.8l1.6,1.2c3.5,2,6.3.4,6.3-3.7a8.8,8.8,0,0,0-.2-1.6l-.7-.2v.2C213.5,384.8,212.8,386.4,211.4,387.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M208.1,380.8l.2-.7-2.4-.8,1.5-6.1c-3.1-1.4-5.6.3-5.6,4a12.1,12.1,0,0,0,1,4.4,12.7,12.7,0,0,0,4.1,4.2c1.6.9,2.9,1,3.9.5s1.6-1.8,1.6-3.7v-.4Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M208.5,379.1l.2-.7-.6-.2,1-4-.6-.4-1.2,4.9Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M215.3,379.7l.3.9-5.4-1.7-.2.7,3.2,1v.6l2.7.9a27.6,27.6,0,0,0-.8-2.7C215.3,379.3,215.3,379.5,215.3,379.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M210.5,377.8l3.7,1.2a13,13,0,0,0-2.6-5.1h-.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M208.7,378.4l1.5.5,5.4,1.7-.3-.9c0-.2-.1-.3-.1-.5a14.7,14.7,0,0,0-4.7-7.9l-.6-.5-.8,3.5-1,4Zm1.9-5.7,1,1.2a14.5,14.5,0,0,1,2.6,5.1l-3.7-1.2-1.1-.4Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M213.2,380.6l-3.2-1-1.5-.5-1.3-.4,1.2-4.9.3-1.1-.3-.2a8.3,8.3,0,0,0-1.6-1.2c-1.9-1.1-3.7-1.3-5-.5s-2.1,2.5-2.1,4.6a14.4,14.4,0,0,0,6.6,11.4h.2a6.7,6.7,0,0,0,2.9.8,5.3,5.3,0,0,0,2-.5c1.4-.8,2.1-2.5,2.1-4.6v-.2a6.8,6.8,0,0,0-.2-1.4v-.4Zm-.9,2c0,1.8-.5,3.1-1.6,3.7a3.8,3.8,0,0,1-3.9-.5,11.8,11.8,0,0,1-4.1-4.2,12.6,12.6,0,0,1-2-6.2c0-1.8.5-3.1,1.6-3.7a2.1,2.1,0,0,1,1.4-.4,6.3,6.3,0,0,1,2.6.8l1.2.8v.2l-1.5,6.1,2.4.8,3.9,1.3a2.5,2.5,0,0,1,.1.8A.9.9,0,0,0,212.3,382.6Z"
          transform="translate(-0.5 -0.8)"
        />
      </g>
      <g id="Graph2">
        <path
          class="cls-3"
          d="M68,325.7l.6.4,1.4-.8a.1.1,0,0,1,.1-.1,1.2,1.2,0,0,1,1.3.1L95.1,339a3.8,3.8,0,0,1,.9.9l.4-.2a3.9,3.9,0,0,0-1.3-1.7L71.4,324.3c-.2-.1-.5-.3-.8-.1a.1.1,0,0,0-.1.1L68,325.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M95.1,339,71.4,325.3a1.2,1.2,0,0,0-1.3-.1.1.1,0,0,0-.1.1l-1.4.8,23,13.3a4.8,4.8,0,0,1,1.7,2l2.6-1.6A3,3,0,0,0,95.1,339Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M95.5,337.3,71.8,323.6a1.4,1.4,0,0,0-1.6-.2H70l-3.5,2.1h-.1a2.2,2.2,0,0,0-.9,1.9v16.6a5.1,5.1,0,0,0,2.2,4.1L91.2,362l1,.3h.7l3.7-2a2.5,2.5,0,0,0,.9-2V341.4A4.8,4.8,0,0,0,95.5,337.3Zm-3.9,24L68,347.6a4.3,4.3,0,0,1-1.7-3.4V327.6a1.5,1.5,0,0,1,.5-1.2c.3-.2.5-.1.8.1l23.7,13.7a4.3,4.3,0,0,1,1.7,3.4v16.6a1.5,1.5,0,0,1-.5,1.2A.8.8,0,0,1,91.6,361.3Zm-21-37.1c.3-.2.6,0,.8.1L95.1,338a3.4,3.4,0,0,1,1.3,1.7l-.4.2-2.6,1.6a4.2,4.2,0,0,0-1.7-2l-23-13.3-.6-.4H68l2.6-1.6Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M83.2,353h0v-7c0-.5.3-.7.7-.5l1.5.9v-.3a1.1,1.1,0,0,0-.5-.9l-2.2-1.3s-.1,0-.1.2v8.1C82.8,352.4,83,352.9,83.2,353Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M73.2,347.1V345c0-.5.3-.6.6-.5l1.6.9v-.3a1.2,1.2,0,0,0-.4-.8L72.6,343h0v3.2a1.2,1.2,0,0,0,.4.8Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M78.1,350.1V338.3c0-.6.4-.9.8-.6l1.4.8h0a1.8,1.8,0,0,0-.6-1.3L77.8,336h-.1a.6.6,0,0,0-.1.4v12.5A1.5,1.5,0,0,0,78.1,350.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M92.4,361.4a1.4,1.4,0,0,0,.5-1.2V343.6a4.5,4.5,0,0,0-1.7-3.4L67.5,326.5c-.3-.2-.5-.3-.8-.1a1.4,1.4,0,0,0-.5,1.2v16.6a4.5,4.5,0,0,0,1.7,3.4l23.7,13.7C91.9,361.5,92.2,361.6,92.4,361.4ZM81.9,343.9a.9.9,0,0,1,.5-.9c.3-.2.5-.1.9,0l2.2,1.3a2,2,0,0,1,.9,1.6v.9a1.8,1.8,0,0,1,.5,1.1V356c-.1.5-.4.7-.7.5L84,355.2a1.6,1.6,0,0,1-.7-1.3h0l-.5-.3a2,2,0,0,1-.9-1.6Zm-10.1-.7a.8.8,0,0,1,.5-.8c.3-.2.5-.1.8,0l2.4,1.4a1.8,1.8,0,0,1,.8,1.5v.8l.4.4V336.4a1.1,1.1,0,0,1,.5-1,.9.9,0,0,1,1,0l1.9,1.1a2.6,2.6,0,0,1,1.1,2v.5a2.2,2.2,0,0,1,.5,1.4v12.5c.1.6-.4.9-.8.6L79,352.4a2,2,0,0,1-.8-1.4l-.4-.2a2.4,2.4,0,0,1-.9-1.1v.7c-.1.5-.4.6-.6.5l-2.4-1.4a1.3,1.3,0,0,1-.6-1.2h0l-.5-.3a1.8,1.8,0,0,1-.8-1.5v-3.3Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M80.6,352.1h-.4l-.5-.2-1.5-.9a2,2,0,0,0,.8,1.4l1.9,1.1c.5.3.9,0,.8-.6V340.4a2.2,2.2,0,0,0-.5-1.4v12A2.4,2.4,0,0,1,80.6,352.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M78.1,338.3v11.8h.1l1.9,1.1h.1a.6.6,0,0,0,.1-.4V338.4l-1.4-.8C78.5,337.4,78.1,337.6,78.1,338.3Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M76.8,349.6a2,2,0,0,0,.9,1.1l.4.2,1.5.9.5.2h.4a1.2,1.2,0,0,0,.5-1.1V338.4a2.6,2.6,0,0,0-1.1-2L78,335.3a.9.9,0,0,0-1,0,1.1,1.1,0,0,0-.5,1v10.1a1.9,1.9,0,0,1,.2.7v2.5Zm.7-13.3a.6.6,0,0,1,.1-.4h.1l1.9,1.1a1.5,1.5,0,0,1,.6,1.3h0v12.5a.6.6,0,0,1-.1.4H80l-1.9-1.1H78a1.7,1.7,0,0,1-.5-1.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M86,355l-.5.2L85,355l-1.7-1h0a1.9,1.9,0,0,0,.7,1.3l2.2,1.3c.4.2.6,0,.7-.5V348a1.9,1.9,0,0,0-.5-1.1v7.3A1.2,1.2,0,0,1,86,355Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M83.3,345.9V353l2.1,1.2a.3.3,0,0,0,.1-.2v-7.8l-1.5-.9C83.6,345.2,83.3,345.4,83.3,345.9Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M82.8,353.7l.5.3,1.7,1,.5.2.5-.2a1.1,1.1,0,0,0,.5-.9v-8.2a1.9,1.9,0,0,0-.9-1.6L83.4,343c-.4-.1-.6-.2-.9,0a1.1,1.1,0,0,0-.5.9V352A1.8,1.8,0,0,0,82.8,353.7Zm0-9.8c0-.2.1-.2.1-.2L85,345a1.1,1.1,0,0,1,.5.9V354a.3.3,0,0,1-.1.2L83.3,353h-.1a1.1,1.1,0,0,1-.5-.9v-8.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M73.2,345v2.1l2.2,1.3h0v-2.8l-1.6-.9C73.4,344.4,73.2,344.6,73.2,345Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M75.8,349.2h-.9l-1.8-1.1h0a1.6,1.6,0,0,0,.6,1.2l2.4,1.4c.3.2.5,0,.6-.5V347a1.9,1.9,0,0,0-.2-.7.8.8,0,0,0-.4-.4v2.4C76.3,348.8,76.1,349.1,75.8,349.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M72.6,347.9l.5.3,1.8,1.1h.9a.9.9,0,0,0,.5-.8v-3.3a2.2,2.2,0,0,0-.8-1.5l-2.4-1.4c-.3-.1-.5-.2-.8,0a.9.9,0,0,0-.5.8v3.2A2.3,2.3,0,0,0,72.6,347.9Zm0-4.8h0l2.4,1.2a1.2,1.2,0,0,1,.4.8v3.1h0L73.2,347H73a1.2,1.2,0,0,1-.4-.8Z"
          transform="translate(-0.5 -0.8)"
        />
      </g>
      <g id="Cake">
        <path
          class="cls-3"
          d="M167.2,302h.9a9.4,9.4,0,0,1,5.6-.6l.5-.3v-.2h.1a8.7,8.7,0,0,0-6,.6H168l-.3.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M168.1,302a14,14,0,0,1,3.4.5l2.2-1.2A9.4,9.4,0,0,0,168.1,302Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M160.2,308.3c-3.2,8,1.2,21.6,9.8,30.2,5,5,10.6,7.5,15,6.7,2.7-.5,4.8-2.4,6-5.4a15.9,15.9,0,0,0,.8-3.3l-16.3-12-.4-.3v-.5l-1.6-8.6-2.2-12a12.5,12.5,0,0,0-3.2-.5C164.5,302.7,161.7,304.6,160.2,308.3Z"
          transform="translate(-0.5 -0.8)"
        />
        <polygon
          class="cls-3"
          points="178.3 323.2 193.2 334.2 194 333.8 178.2 322.1 175.9 323.3 176.8 324 178.3 323.2"
        />
        <polygon class="cls-2" points="178.3 323.2 176.8 324 191.8 335 193.2 334.2 178.3 323.2" />
        <path
          class="cls-3"
          d="M188,305.7a23.9,23.9,0,0,0-9.5-6.2l-2.7,1.5,1.2.5,1.5-.8c3.2.9,6.6,3.1,9.9,6.4a41.3,41.3,0,0,1,6.7,9,30.5,30.5,0,0,1,1.9,4.1h0a29.6,29.6,0,0,0-2.4-5.5A39.4,39.4,0,0,0,188,305.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M188.4,307.1c-3.3-3.3-6.7-5.5-9.9-6.4l-1.5.8a27.7,27.7,0,0,1,7.8,5.6,38.4,38.4,0,0,1,6.5,8.9h.1l.2.4a29.6,29.6,0,0,1,2.4,5.5l3-1.6c-.6-1.4-1.2-2.7-1.9-4.1A42.8,42.8,0,0,0,188.4,307.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-4"
          d="M199.7,327.8a37.9,37.9,0,0,0-4.3-13.5,38.3,38.3,0,0,0-6.7-9.1,24.4,24.4,0,0,0-10.1-6.5h-.2l-3.3,1.7a11,11,0,0,0-7,.3l-.6.4h-.3l-3.8,2h0a9.4,9.4,0,0,0-4,4.9c-3.3,8.3,1.2,22.3,10,31.2,4.5,4.5,9.5,7,13.8,7h1.9a8.5,8.5,0,0,0,3.5-1.5l2.1-1,1.2-.6h.1a10.2,10.2,0,0,0,3.6-4.7,14.3,14.3,0,0,0,.9-3.7h0l.4-.3,2.7-1.4v-.2A19.1,19.1,0,0,0,199.7,327.8Zm-31.5-26.4a8.7,8.7,0,0,1,6-.6h-.1v.2l-.5.3-2.2,1.2a14,14,0,0,0-3.4-.5h-.9l.5-.3.3-.2Zm16,6.3a36.3,36.3,0,0,1,6.4,8.6L179,321.6l-3.7-19.9A24.5,24.5,0,0,1,184.2,307.7ZM195,333.8l-12.7-9.4,6.6,3,6.1,2.8Zm-16.3-10.9,15.9,11.7-.8.5-1.4.8-15-11-.9-.7Zm16.2,6.3-1-.4-12.2-5.6-2.1-.9,11.3-5.2A36.6,36.6,0,0,1,194.9,329.2Zm2-9-3,1.6c-.7-1.8-1.5-3.7-2.4-5.5l-.2-.4h-.1a38.4,38.4,0,0,0-6.5-8.9,24.7,24.7,0,0,0-7.8-5.6l-1.2-.5,2.7-1.5a23.9,23.9,0,0,1,9.5,6.2,39.4,39.4,0,0,1,6.6,9,37.7,37.7,0,0,1,2.4,5.6Zm-28.8-17.5a12.5,12.5,0,0,1,3.2.5l2.2,12,1.6,8.6v.5l.4.3,16.3,12a26.6,26.6,0,0,1-.8,3.3,8.3,8.3,0,0,1-6,5.4c-4.4.8-10-1.6-15-6.7-8.6-8.7-13-22.2-9.8-30.2C161.7,304.6,164.5,302.7,168.1,302.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M175.2,301.7l3.7,19.9,11.6-5.3a36.3,36.3,0,0,0-6.4-8.6A23,23,0,0,0,175.2,301.7Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M188.8,327.4l-6.6-3,12.7,9.4a21.6,21.6,0,0,0,0-3.6Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-3"
          d="M179.6,322.3l2.1.9,9-4a28.1,28.1,0,0,1,3.2,9.5l1,.4a37.6,37.6,0,0,0-3.9-12.2Z"
          transform="translate(-0.5 -0.8)"
        />
        <path
          class="cls-2"
          d="M181.7,323.2l12.2,5.6a33.3,33.3,0,0,0-3.2-9.5Z"
          transform="translate(-0.5 -0.8)"
        />
      </g>
      <g id="Graph">
        <polygon
          class="cls-3"
          points="155.7 345.5 154.5 346.1 136 310 137.3 309.3 135.3 305.2 128.2 308.4 129.9 311.8 129.3 312.1 143.7 340.4 156.9 348.1 155.7 345.5"
        />
        <polygon
          class="cls-3"
          points="107 274.5 105.2 270.9 103.4 271.5 100.9 272.4 102.7 275.8 99.2 277.6 118.5 316.2 124.4 313.6 105.5 275.3 107 274.5"
        />
        <polygon
          class="cls-3"
          points="73.8 230.8 72.4 228.1 72.4 245.9 90.7 280.2 97.3 277.9 72.5 231.5 73.8 230.8"
        />
        <polygon
          class="cls-3"
          points="128.3 313.7 117.7 318.4 98.2 279.3 89.9 282.2 72.4 249.4 72.4 299.3 141.1 338.9 128.3 313.7"
        />
        <path
          class="cls-4"
          d="M158.5,350.5l5.6-2.9-22.9-45.3-.8.4-9.8,4.4-19.5-39.2-.5.3-7.7,2.8L77.7,224l-5.4,2.7H72V245l-7.7-14.4,2.9-1.6-7.1-4.5-.3,8.4,3-1.6,9.1,17.1v52.1l70.3,40.6,8.7,17.1,1.5-.7-7.6-14.9,13.2,7.6.2.3ZM72.9,250.2,90.4,283l8.3-2.9,19.5,39.1,10.6-4.7,12.8,25.2L72.9,300Zm56.9,62.7-.3-.6-4.6,2.1L119,317,99.7,278.4l-.2-.3-1.8.6L91.1,281,72.8,246.7V228.9l1.4,2.7,23,43.1.4-.2h0l3.7-1.3,2.5-.9,1.8-.6,1.8,3.7L125,310.8l.4-.2h0l3.2-1.4h0l7-3.1,2,4L156,346.4l1.3,2.5-13.2-7.6Zm28.9,36.6-1.8-3.5-18.4-36.3-2.1-4.1,4.3-2.3,22.2,43.9Zm-30.5-41.3-2.6,1.4-17.3-34.7-1.8-3.6,4.3-2.3,19.1,38.3Zm-27.5-36.3-3,1.6L75,231.2l-2.1-3.9,4.3-2.3L102,271.1Z"
          transform="translate(-0.5 -0.8)"
        />
        <polygon
          class="cls-3"
          points="72.5 226.5 74.5 230.4 77.6 228.8 100.2 271.1 101.5 270.4 76.8 224.3 72.5 226.5"
        />
        <polygon
          class="cls-2"
          points="100.9 272.4 97.2 273.7 97.2 273.7 96.9 273.9 73.8 230.8 72.5 231.5 97.3 277.9 99.1 277.3 99.2 277.6 102.7 275.8 100.9 272.4"
        />
        <polygon class="cls-2" points="74.5 230.4 97.2 272.7 100.2 271.1 77.6 228.8 74.5 230.4" />
        <polygon
          class="cls-3"
          points="110.3 268.2 106 270.5 107.8 274.1 110.5 272.7 127.7 307.4 129.4 306.5 110.3 268.2"
        />
        <polygon
          class="cls-2"
          points="128.2 308.4 128.2 308.3 125 309.8 125 309.8 124.6 310 107 274.5 105.5 275.3 124.4 313.6 129 311.5 129.3 312.1 129.9 311.8 128.2 308.4"
        />
        <polygon
          class="cls-2"
          points="107.8 274.1 125.1 308.8 127.7 307.4 110.5 272.7 107.8 274.1"
        />
        <polygon
          class="cls-3"
          points="140.3 302.6 136 304.8 138 308.9 141.1 307.3 159.5 343.5 156.4 345.2 158.2 348.7 162.5 346.4 140.3 302.6"
        />
        <polygon class="cls-2" points="154.5 346.1 155.7 345.5 137.3 309.3 136 310 154.5 346.1" />
        <polygon class="cls-2" points="159.5 343.5 141.1 307.3 138 308.9 156.4 345.2 159.5 343.5" />
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    analytics() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-analyticsuk",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
            ease: "sine",
          },
        })
        .add("analytics")
        .from(
          "#BigBen path, #BigBen polygon",
          {
            stagger: 0.01,
            scale: 0.4,
            opacity: 0,
            transformOrigin: "50% 100%",
          },
          "analytics"
        );
    },
  },
  mounted() {
    this.analytics();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #fbb03b;
}

.cls-2 {
  fill: #fff;
}

.cls-3 {
  fill: #ffad43;
}

.cls-4 {
  fill: #0e1e25;
}
</style>